export const WebviewUserDataHelp = [
  {
    id: 8,
    title: 'Informasi Customer Support',
    child: [
      {
        title: 'Contact CS',
        subdata: [
          {
            title: 'Email',
            content: [
              {
                text: `
                                    <a href="mailto:help@halojasa.com">help@halojasa.com</a> (Komplain dan support customer/vendor)
                                `
              }
            ]
          },
          {
            title: 'Telepon',
            content: [
              {
                text:
                  '<a href="tel:+62895380066656" style="color:black">+62 895-3800-66656</a> (Whatsapp Customer Care) '
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 1,
    title: 'Pusat Bantuan User',
    child: [
      {
        title: 'Cara Mendaftarkan Akun Halo Jasa',
        subdata: [
          {
            title: 'Bagaimana cara mendaftar dengan email?',
            content: [
              {
                text: 'Silakan anda log in ke akun aplikasi Halo Jasa.'
              },
              {
                text:
                  'Unduh dan install aplikasi halo jasa dari Play Store (Android) / App Store (iOS).'
              },
              {
                text:
                  'Masuk aplikasi dan pada tampilan utama, pilih salah satu cara pembuatan akun (Google, Facebook, atau nomor telepon) silahkan Anda pilih tombol Daftar.'
              },
              {
                text:
                  'Lengkapi semua data yang diminta dengan email dan nomor ponsel yang aktif.'
              },
              {
                text:
                  'Setelah Anda mengisi form tersebut, Anda dapat melanjutkan proses registrasi dengan cara klik button Daftar.'
              },
              {
                text:
                  'Anda akan mendapatkan SMS pada handphone yang Anda daftarkan, berisi 4-digit kode OTP, masukkan kode tersebut INGAT! harap tidak memberitahukan kode ini kepada siapapun termasuk oknum yang mengatasnamakan halo jasa).'
              }
            ]
          },
          {
            title: 'Bagaimana cara mendaftar dengan Facebook?',
            content: [
              {
                text:
                  'Silakan unduh dan install aplikasi Halo Jasa dari Play Store (Android) / App Store (iOS).'
              },
              {
                text:
                  'Masuk aplikasi dan pada tampilan utama, pilih salah satu cara pembuatan akun (Google, Facebook, atau nomor telepon) silahkan Anda pilih tombol Daftar.'
              },
              {
                text:
                  'Pada halaman tersebut, Anda dapat melihat bahwa Anda dapat juga registrasi dengan menggunakan facebook, silahkan Anda memilih registrasi dengan menggunakan Facebook.'
              },
              {
                text:
                  'Setelah Anda memilih registrasi dengan Facebook. Anda akan diarahkan ke halaman Facebook untuk melakukan verifikasi akun Facebook Anda.'
              },
              {
                text:
                  'Setelah melakukan aktivasi, Anda akan diminta untuk mengisi form dan mengisi beberapa data seperti password dan nomor telepon.'
              },
              {
                text:
                  'Setelah Anda mengisi form tersebut, Anda dapat melanjutkan proses registrasi dengan cara klik button Daftar.'
              },
              {
                text:
                  'Anda akan mendapatkan SMS pada handphone yang Anda daftarkan, berisi 4-digit kode OTP, masukkan kode tersebut INGAT! harap tidak memberitahukan kode ini kepada siapapun termasuk oknum yang mengatasnamakan halo jasa).'
              }
            ]
          }
        ]
      },
      {
        title: 'Aktivasi Akun Halo Jasa',
        subdata: [
          {
            title: 'Bagaimana cara aktivasi akun melalui sms?',
            content: [
              {
                text: 'Pertama, silahkan Anda membuka handphone Anda.'
              },
              {
                text:
                  'Kemudian cek kode aktivasi yang dikirimkan ke nomor handphone Anda.'
              },
              {
                text: 'Masukkan kode aktivasi tersebut.'
              },
              {
                text:
                  'Kemudian Anda akan diarahkan ke halaman login pada website Halo Jasa.'
              }
            ]
          },
          {
            title: 'Bagaimana cara aktivasi akun melalui Email?',
            content: [
              {
                text:
                  'Akan segera muncul pemberitahuan yang mengharuskan user melakukan verifikasi akun untuk aktivasi melalui email ketika user ingin mengaktifkan Halo Point.'
              },
              {
                text: 'Isi kembali alamat Email anda yang aktif.'
              },
              {
                text:
                  'Ketika Email yang diisi tidak sesuai dengan yang Email sebelumnya maka akan muncul pemberitahuan “Email tidak terdaftar”'
              },
              {
                text:
                  'Ketika Email yang diisi sesuai dengan yang sebelumnya, akan terdapat notifikasi “Saat ini email Anda belum terverifikasi. Lakukan dan aktifkan sekarang”'
              },
              {
                text: 'Klik button “Aktivasi Sekarang”'
              },
              {
                text:
                  'Jika aktivasi melalui Email telah berhasil, akan dikirimkan sebuah pemberitahuan melalui Email sebagai notifikasi berhasilnya pendaftaran sebagai pencari jasa'
              }
            ]
          },
          {
            title: 'Bagaimana jika tidak menerima SMS aktivasi?',
            content: [
              {
                text:
                  'Klik button “Resend Kode Aktivasi” di layar permintaan pengiriman SMS aktivasi.'
              },
              {
                text:
                  'Masukkan kembali kode sesuai dengan yang telah dikirim ulang ke nomor user. Setelah kode terisi dengan benar, centang “Saya bukan robot”'
              },
              {
                text:
                  'Klik kembali “Verifikasi akun”. Maka verifikasi akun melalui sms telah sukses dan langsung menampilkan halaman “Sign In”'
              }
            ]
          },
          {
            title: 'Bagaimana jika tidak menerima Email aktivasi?',
            content: [
              {
                text:
                  'Pilih "Resend Kode Aktivasi" atau cek folder spam di email Anda.'
              },
              {
                text: 'Kemudian cek kembali Email Anda.'
              }
            ]
          }
        ]
      },
      {
        title: 'Lupa Kata Sandi Halo Jasa',
        subdata: [
          {
            title: 'Bagaimana jika lupa kata sandi?',
            content: [
              {
                text: 'Silakan anda log in ke akun aplikasi Halo Jasa'
              },
              {
                text: 'Pilih ikon akun disudut kanan bawah'
              },
              {
                text:
                  'Pilih menu profile dan temukan halaman bertulisan forgot password'
              },
              {
                text:
                  'Silahkan masukkan nomor handphone yang telah Anda daftarkan di Halo Jasa dan jangan lupa beri tanda centang pada checkbox “I’m not a robot”.'
              },
              {
                text:
                  'Pilih tombol resend kode aktivasi dan Halo Jasa akan mengirimkan SMS konfirmasi reset password ke handphone Anda.'
              },
              {
                text:
                  'Silahkan cek apakah Anda telah menerima 6 digit angka di SMS konfirmasi reset password dari Halo Jasa di bagian kode reset.'
              },
              {
                text:
                  'Silahkan masukkan 6 digit angka tersebut dan beri tanda centang di checkbox “I’m not a robot”. Lalu pilih tombol kirim reset password.'
              },
              {
                text: 'Isi data password baru'
              },
              {
                text: 'Pilih update password'
              },
              {
                text:
                  'Reset password selesai dan sekarang Anda berhasil login ke akun Halo Jasa Anda.'
              }
            ]
          },
          {
            title: 'Mengapa saya tidak bisa Login di akun Halo Jasa?',
            content: [
              {
                text:
                  'Anda belum melakukan aktivasi akun. Silahkan baca cara untuk melakukan aktivasi akun.'
              },
              {
                text:
                  'Masalah lain, kata sandi atau password yang Anda masukkan salah. Silahkan baca panduan jika Anda lupa kata sandi atau password Anda.'
              },
              {
                text:
                  'Jika kedua poin di atas telah dicoba dan Anda masih tidak dapat login. Kemungkinan akun Anda disalahgunakan oleh pihak lain atau sedang dibekukan oleh Tim Policy Halo Jasa. Silahkan laporkan segera permasalahan login ke Customer Support Halo Jasa melalui fitur Hubungi Halo Jasa.'
              }
            ]
          }
        ]
      },
      {
        title: 'Pengaturan Akun Halo Jasa',
        subdata: [
          {
            title: 'Bagaimana cara mengubah nama akun?',
            content: [
              {
                text: 'Silahkan Anda login ke akun aplikasi Halo Jasa.'
              },
              {
                text: 'Pilih ikon akun di sudut kanan bawah.'
              },
              {
                text: 'Pilih profile'
              },
              {
                text: 'Pilih profile pribadi'
              },
              {
                text: 'Silahkan isi kolom nama dengan akun yang Anda inginkan'
              },
              {
                text: 'Kemudian pilih "Simpan"'
              }
            ]
          },
          {
            title: 'Bagaimana cara mengubah email akun Halo Jasa?',
            content: [
              {
                text: 'Silahkan Anda login ke akun Halo Jasa.'
              },
              {
                text: 'Pilih ikon profile di sudut kanan atas.'
              },
              {
                text: 'Pilih menu tab setting.'
              },
              {
                text:
                  'Sekarang Anda diarahkan ke setting informasi kontak. Silahkan Anda mengisinya dengan Email yang baru/nomor telepon yang baru dan pilih tombol simpan.'
              },
              {
                text:
                  'Silahkan cek verifikasi di email yang telah didaftarkan di Halo Jasa'
              }
            ]
          },
          {
            title:
              'Bagaimana cara mengubah kata sandi (password) pada akun Halo Jasa?',
            content: [
              {
                text: 'Silahkan Anda login ke akun Halo Jasa.'
              },
              {
                text: 'Pilih ikon akun di sudut kanan bawah.'
              },
              {
                text: 'Pilih menu tab setting.'
              },
              {
                text:
                  'Sekarang Anda diarahkan ke setting. Silahkan Anda memilih menu password.'
              },
              {
                text:
                  'Silahkan klik isi dengan password lama dan silahkan ubah password baru yang akan dicantumkan pada akun Halo Jasa Anda dan pilih simpan.'
              }
            ]
          },
          {
            title: 'Bagaimana cara mengubah nomor telepon pada akun Halo Jasa?',
            content: [
              {
                text: 'Silahkan Anda login ke akun Halo Jasa.'
              },
              {
                text: 'Pilih ikon akun di sudut kanan bawah.'
              },
              {
                text: 'Pilih profile.'
              },
              {
                text: 'Pilih profil pribadi.'
              },
              {
                text: 'Pilih button change.'
              },
              {
                text:
                  'Anda akan diarahkan ke setting informasi kontak. Silahkan isi nomor handphone Anda yang baru dan masukkan password Anda dan pilih simpan.'
              }
            ]
          },
          {
            title:
              'Bagaimana jika nomor telepon yang digunakan sebelumnya hilang atau tidak aktif lagi?',
            content: [
              {
                text:
                  'Jika nomor telepon yang anda gunakan sudah tidak aktif atau tidak bisa digunakan untuk mengirimkan kode OTP, silakan email ke info@halo-jasa.com dengan melampirkan foto Buku Tabungan dan Kartu Identitas (KTP/SIM/Paspor) sesuai dengan data Pemilik Akun, informasikan alamat email dari akun terkait dan nomor telepon baru yang akan digunakan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Bagaimana dengan vendor favorit?',
        subdata: [
          {
            title: 'Bagaimana dengan vendor favorit?',
            content: [
              {
                text:
                  'Jasa Favorit adalah jasa yang Anda sukai, atau Anda merasa puas dengan layanan yang telah diberikan oleh penyedia jasa tersebut. Anda juga dapat men-favorite kan beberapa jasa yang memang Anda sukai.'
              },
              {
                text:
                  'Untuk membuat jasa favorit , Anda dapat membuat profile penyedia jasa tertentu dan sesuai dengan keinganan Anda. Kemudian silahkan menekan tombol Favoritkan, dan akan muncul pemberitahuan bahwa Anda telah berhasil menambahkan penyedia jasa tersebut kedalam list favorite Anda.'
              },
              {
                text:
                  'Login ke dalam akun Halo Jasa. Setelah login berhasil, Anda akan di alihkan langsung ke dashboard akun Halo Jasa'
              },
              {
                text: 'Pilih pengaturan yang tersedia disebelah kanan homepage'
              },
              {
                text: 'Klik “Pesan Bantuan”'
              },
              {
                text:
                  'Silahkan memilih tab Jasa Favorite dan Anda akan melihat jasa yang telah Anda favorite-kan sebelumnya dan untuk tab terakhir dilihat adalah halaman yang menunjukkan profile penyedia jasa yang terakhir Anda lihat atau buka.'
              }
            ]
          }
        ]
      },
      {
        title: 'Cara transaksi dan pembayaran?',
        subdata: [
          {
            title: 'Bagaimana cara kerja bertransaksi di Halo jasa?',
            content: [
              {
                text:
                  'Halo jasa memberikan kemudahan dalam bertransaksi dengan menyediakan sistem cash on delivery order (COD) dan juga pembayaran dengan e money dari pihak ketiga yaitu dana digital indonesia dari PT. Espay Debit Indonesia Koe dan juga e-money ovo dari PT. Visionet Internasional'
              }
            ]
          },
          {
            title: 'Bagaimana cara bertransaksi dengan e money DANA?',
            content: [
              {
                text:
                  'Pada proses Order, Pencari Jasa memilih HaloPay sebagai opsi metode pembayaran.'
              },
              {
                text:
                  'Setelah Penyedia Jasa sepakat untuk mengerjakan order dari Pencari Jasa, sistem akan mengirimkan invoice untuk membayar secara full serta petunjuk cara melakukan pembayaran melalui HaloPay kepada Pencari Jasa.'
              },
              {
                text:
                  'Saat Pencari Jasa telah selesai melakukan pembayaran, Halo Jasa akan mengeluarkan Surat Perintah Kerja (SPK) kepada Penyedia Jasa untuk segera melakukan pekerjaan sesuai dengan yang di-order oleh Pencari Jasa.'
              },
              {
                text:
                  'Penyedia Jasa yang telah selesai melaksanakan order diharuskan untuk melakukan konfirmasi penyelesaian pekerjaan melalui sistem Halo Jasa.'
              },
              {
                text:
                  'Team Halo Jasa akan melakukan konfirmasi kepada Pencari Jasa mengenai status penyelesaian order oleh Penyedia Jasa.'
              },
              {
                text:
                  'Jika pihak Pencari Jasa telah memberikan konfirmasi penyelesaian pekerjaan atau setelah 3 x 24 Jam tidak memberikan konfirmasi, maka Halo Jasa akan langsung mengirim dana kepada Penyedia Jasa.'
              }
            ]
          }
        ]
      },
      {
        title: 'Cash on Delivery (COD)',
        subdata: [
          {
            title: 'Apa itu Cash on Delivery (COD)?',
            content: [
              {
                text:
                  'COD adalah salah satu opsi pembayaran melalui Halo Jasa dimana Pencari Jasa bisa melakukan pembayaran secara langsung kepada Penyedia Jasa'
              }
            ]
          },
          {
            title:
              'Bagaimanakah proses pembayaran dengan Cash on Delivery (COD)?',
            content: [
              {
                text:
                  'Pada proses Order, Pencari Jasa memilih Cash On Delivery (COD) sebagai opsi metode pembayaran.'
              },
              {
                text:
                  'Setelah Penyedia Jasa sepakat untuk mengerjakan order dari Pencari Jasa, Penyedia Jasa akan langsung menghubungi Pencari Jasa.'
              },
              {
                text:
                  'Pencari Jasa wajib melakukan pembayaran secara langsung kepada Penyedia Jasa saat Order/pekerjaan yang diminta telah selesai dilakukan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Code Voucher Diskon',
        subdata: [
          {
            title: 'Bagaimana cara mendapatkan kode voucher diskon?',
            content: [
              {
                text:
                  'Kode voucher diskon promo akan di rilis pada momen tertentu sesuai ketentuan pada layanan kami. Promo kode voucher ini bisa Anda temukan juga pada akun sosial media Halo Jasa di Facebook, Instagram, Twitter, maupun melalui email promosi. Anda juga cek langsung pada laman aplikasi Halo Jasa Anda.'
              }
            ]
          },
          {
            title: 'Apakah kegunaan kode Voucher Diskon?',
            content: [
              {
                text:
                  'Kode voucher diskon dapat Anda gunakan untuk mendapatkan potongan harga layanan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Manfaat Halo Point',
        subdata: [
          {
            title: 'Manfaat Halo Point',
            content: [
              {
                text:
                  'Poin adalah reward yang Anda dapatkan ketika telah menyelesaikan sebuah order layanan jasa. Poin tersebut nanti nya dapat Anda gunakan sebagai metode pembayaran untuk order Anda selanjutnya. Anda dapat melihat jumlah poin pada Dashboard User Profile Anda.'
              }
            ]
          },
          {
            title: 'Bagaimana Cara Mendapatkan Halo Point?',
            content: [
              {
                text:
                  'Lakukan pemesanan di layanan Halojasa. setiap layanan yang diselesaikan penggunakan akan mendapatkan Halopoint dalam nominal tertentu sesuai dengan loyalti program yang sedang berjalan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Cara memberikan penilaian dan tips',
        subdata: [
          {
            title: 'Apa itu Rating penilaian',
            content: [
              {
                text:
                  'Rating ulasan adalah fitur dimana Pencari Jasa yang telah selesai melakukan transaksi dengan Penyedia Jasa di Halo Jasa dapat memberikan penilaian dan review pada hasil pekerjaan yang diberikan oleh Penyedia Jasa. Tiga hal yang dapat dinilai dalam Rating Ulasan adalah: Kualitas Pekerjaan, Ketepatan Waktu dan Keramahan.'
              }
            ]
          },
          {
            title: 'Apa manfaat memberikan Rating Ulasan',
            content: [
              {
                text:
                  'Rating ulasan akan berguna untuk menentukan reputasi Penyedia Jasa dan juga sebagai bahan pertimbangan bagi Pencari Jasa untuk memilih Penyedia Jasa terpercaya. Rating tersebut juga dapat dijadikan sebagai bahan evaluasi oleh Penyedia Jasa untuk terus-menerus meningkatkan kualitas layanan mereka.'
              }
            ]
          },
          {
            title: 'Bagaimana cara memberikan Rating Ulasan?',
            content: [
              {
                text: 'Pilih Icon PROFILE'
              },
              {
                text: 'Pilih Menu PROFILE'
              },
              {
                text: 'Di halaman Profile Pribadi, pilih Tab Ulasan Saya'
              },
              {
                text:
                  'Pilih Antara Tab Ulasan Halo Jasa untuk transaksi yang dilakukan di marketplace atau Ulasan Halo Express untuk transaksi yang dilakukan melalui Halo Express'
              },
              {
                text:
                  'Berikan penilaian rating Bintang pada pilihan, Kualitas Layanan, Ketepatan waktu dan Keramahan Pelayanan.'
              },
              {
                text: 'Tulis review Anda'
              },
              {
                text: 'Tekan Submit'
              }
            ]
          }
        ]
      },
      {
        title: 'Informasi pesanan',
        subdata: [
          {
            title: 'Bagaimana cara melihat progres pesanan?',
            content: [
              {
                text:
                  '<ul><li>Buka aplikasi Halo Jasa.</li><li>Klik tab icon &ldquo;pemesanan&rdquo;.</li><li>Klik order yang sudah anda buat.</li><li>Detail dan progres pesanan anda tercantum pada order tersebut.</li></ul>'
              }
            ]
          },
          {
            title: 'Bagaimana cara membatalkan pesanan?',
            content: [
              {
                text:
                  '<ul><li>Buka aplikasi Halo Jasa</li><li>Klik tab icon &ldquo;Pemesanan&rdquo;.</li><li>Klik order yang sudah anda buat.</li><li>Klik tombol icon<em>Batalkan Pesanan</em> yang berada pada bagian bawah layar.</li><li>Sertakan alasan anda membatalkan pesanan.</li><li>Klik icon &ldquo;Batalkan Pesanan&rdquo;.</li></ul>'
              }
            ]
          },
          {
            title: 'Bagaimana cara melihat histori transaksi pesanan?',
            content: [
              {
                text:
                  '<ul><li>Buka Aplikasi Halo Jasa.</li><li>Klik tab icon &ldquo;Pemesanan&rdquo;.</li><li>Klik icon tombol histori pemesanan pada pojok kanan atas layar.</li><li>Semua histori pesanan anda tercatat pada laman tersebut.</li></ul>'
              }
            ]
          },
          {
            title: 'Bagaimana cara menghubungi vendor?',
            content: [
              {
                text:
                  '<ul><li>Buka Aplikasi Halo Jasa.</li><li>Klik tab icon &ldquo;Pemesanan&rdquo;.</li><li>Klik order yang sudah anda buat.</li><li>Anda akan diarahkan ke laman detail pemesanan.</li><li>Klik tombol icon <em>SMS</em> atau <em>CALL</em> sesuai kebutuhan anda.</li></ul>'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Informasi Layanan',
    child: [
      {
        title: 'Halo  Massage',
        subdata: [
          {
            title: 'Apa itu Halo Massage?',
            content: [
              {
                text:
                  'Halo Massage adalah layanan On-Demand pijat relaksasi dengan masseur professional dan berpengalaman yang dapat anda pesan pada aplikasi Halo Jasa.'
              }
            ]
          },
          {
            title: 'Layanan apa saja yang bisa dipesan?',
            content: [
              {
                text:
                  '<p>Layanan yang tersedia pada Halo Massage antara lain:</p><ol><li>Reflexology</li><li>Full Body Massage</li><li>Full Body Massage + Kerokan.</li></ol>'
              }
            ]
          },
          {
            title: 'Area mana saja yang sudah tersedia?',
            content: [
              {
                text:
                  'Hingga saat ini, layanan Halo Jasa sudah tersedia di Jakarta, Depok, Tangerang, serta Bekasi.'
              }
            ]
          },
          {
            title: 'Bagaimana cara melakukan pemesanan?',
            content: [
              {
                text:
                  '<ul><li>Pastikan anda sudah login dan meng-aktifkan GPS pada smartphone anda.</li><li>Pilih kategori layanan Halo Massage.</li><li>Tentukan kategori pijat yang anda inginkan.</li><li>Atur durasi layanan yang anda inginkan.</li><li>Pilih jenis kelamin anda dan preferensi jenis kelamin terapis.</li><li>Pilih tanggal layanan Halo Massage anda.</li><li>Tentukan lokasi anda.</li><li>Pilih metode pembayaran.</li><li>Klik &ldquo;Proses Pemesanan&rdquo;</li><li>Cek status order anda pada laman &ldquo;Pemesanan.&rdquo;</li></ul>'
              }
            ]
          },
          {
            title: 'Perlengkapan apa saja yang sudah disediakan?',
            content: [
              {
                text:
                  'Vendor Halo Massage sudah menyediakan peralatan sesuai standarisasi dari Halo Jasa terkait perlengkapan kerja.'
              }
            ]
          },
          {
            title: 'Kapan saja jam operasional layanan ini?',
            content: [
              {
                text:
                  'Layanan Halo Massage tersedia mulai pukul 06:00 – 22:00. Anda dapat memesan layanan ini paling cepat satu jam dari waktu anda saat memilih jadwal untuk hari yang sama. Anda juga dapat menjadwalkan pesanan hingga dua hari kedepan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Halo Auto',
        subdata: [
          {
            title: 'Apa itu Halo Auto?',
            content: [
              {
                text:
                  'Halo Auto adalah layanan On-Demand Cuci mobil atau motor dengan vendor handal. Cuci kendaraan juga disertai pembersihan interior dan wax untuk mobil dan semir ban untuk motor.'
              }
            ]
          },
          {
            title: 'Layanan apa saja yang bisa dipesan?',
            content: [
              {
                text:
                  '<p>Layanan yang tersedia pada Halo Auto antara lain:</p><ol><li>Cuci motor</li><li>Cuci mobil</li><li>Paket Kinclong 1</li><li>Paket Kinclong 2.</li></ol>'
              }
            ]
          },
          {
            title: 'Area mana saja yang sudah tersedia?',
            content: [
              {
                text:
                  'Hingga saat ini, layanan Halo Jasa sudah tersedia di Jakarta, Depok, Tangerang, serta Bekasi.'
              }
            ]
          },
          {
            title: 'Bagaimana cara melakukan pemesanan?',
            content: [
              {
                text:
                  '<ul><li>Pastikan anda sudah login dan meng-aktifkan GPS pada smartphone anda.</li><li>Pilih kategori layanan Halo Auto.</li><li>Pilih jenis kendaraan yang akan dibersihkan.</li><li>Pilih kategori paket layanan yang tersedia.</li><li>Tentukan tanggal layanan Halo Auto anda.</li><li>Tentukan lokasi anda.</li><li>Pilih metode pembayaran.</li><li>Klik &ldquo;Proses Pemesanan&rdquo;</li><li>Cek status order anda pada laman &ldquo;Pemesanan.&rdquo;</li></ul>'
              }
            ]
          },
          {
            title: 'Perlengkapan apa saja yang sudah disediakan?',
            content: [
              {
                text:
                  'Vendor Halo Auto sudah menyediakan peralatan sesuai standarisasi dari Halo Jasa terkait perlengkapan kerja.'
              }
            ]
          },
          {
            title: 'Kapan saja jam operasional layanan ini?',
            content: [
              {
                text:
                  'Layanan Halo Auto tersedia mulai pukul 06:00 – 22:00. Anda dapat memesan layanan ini paling cepat satu jam dari waktu anda saat memilih jadwal untuk hari yang sama. Anda juga dapat menjadwalkan pesanan hingga dua hari kedepan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Halo Fix',
        subdata: [
          {
            title: 'Apa itu Halo Fix?',
            content: [
              {
                text:
                  'Halo Fix adalah layanan On-Demand servis, cuci, bongkar-pasang atau pemasangan AC pada rumah tinggal, apartemen, maupun kantor.'
              }
            ]
          },
          {
            title: 'Layanan apa saja yang bisa dipesan?',
            content: [
              {
                text:
                  '<p>Layanan yang tersedia pada Halo Fix antara lain:</p><ol><li>Bongkar AC</li><li>Bongkar-Pasang AC,</li><li>Cuci AC</li><li>Pasang AC.</li></ol>'
              }
            ]
          },
          {
            title: 'Area mana saja yang sudah tersedia?',
            content: [
              {
                text:
                  'Hingga saat ini, layanan Halo Jasa sudah tersedia di Jakarta, Depok, Tangerang, serta Bekasi.'
              }
            ]
          },
          {
            title: 'Bagaimana cara melakukan pemesanan?',
            content: [
              {
                text:
                  '<ul><li>Pastikan anda sudah login dan meng-aktifkan GPS pada smartphone anda.</li><li>Pilih kategori layanan Halo Fix</li><li>Pilih kategori layanan yang anda inginkan.</li><li>Tentukan jenis lokasi hunian anda.</li><li>Tentukan kategori layanan yang anda inginkan.</li><li>Klik &ldquo;Proses Pesanan&rdquo; untuk langkah berikutnya.</li><li>Pilih tanggal layanan Halo Fix anda.</li><li>Masukkan lokasi anda.</li><li>Pilih metode pembayaran.</li><li>Klik &ldquo;Proses Pemesanan&rdquo;</li><li>Cek status order mu pada laman &ldquo;Pemesanan.&rdquo;</li></ul>'
              }
            ]
          },
          {
            title: 'Perlengkapan apa saja yang sudah disediakan?',
            content: [
              {
                text:
                  'Vendor Halo Fix sudah menyediakan peralatan sesuai standarisasi dari Halo Jasa terkait perlengkapan kerja.'
              }
            ]
          },
          {
            title: 'Kapan saja jam operasional layanan ini?',
            content: [
              {
                text:
                  'Layanan Halo Fix tersedia mulai pukul 06:00 – 22:00. Anda dapat memesan layanan ini paling cepat satu jam dari waktu anda saat memilih jadwal untuk hari yang sama. Anda juga dapat menjadwalkan pesanan hingga dua hari kedepan.'
              }
            ]
          }
        ]
      },
      {
        title: 'Halo Clean',
        subdata: [
          {
            title: 'Apa itu Halo Clean?',
            content: [
              {
                text:
                  'Halo Clean adalah layanan On-Demand pembersihan rumah tinggal, apartemen, maupun kantor.'
              }
            ]
          },
          {
            title: 'Layanan apa saja yang bisa dipesan?',
            content: [
              {
                text:
                  '<p>Layanan yang tersedia pada Halo Clean antara lain:</p><ol><li>Paket Residensial</li><li>Office Cleaning</li><li>Paket Apartemen / Kost</li><li>Home Cleaning.</li></ol>'
              }
            ]
          },
          {
            title: 'Area mana saja yang sudah tersedia?',
            content: [
              {
                text:
                  'Hingga saat ini, layanan Halo Jasa sudah tersedia di Jakarta, Depok, Tangerang, serta Bekasi.'
              }
            ]
          },
          {
            title: 'Bagaimana cara melakukan pemesanan?',
            content: [
              {
                text:
                  '<ul><li>Pastikan anda sudah login dan meng-aktifkan GPS pada smartphone anda.</li><li>Pilih kategori layanan Halo Clean.</li><li>Pilih kategori layanan yang anda inginkan.</li><li>Pilih preferensi jenis kelamin penyedia jasa.</li><li>Tentukan tanggal layanan Halo Clean anda.</li><li>Tentukan lokasi anda.</li><li>Pilih metode pembayaran.</li><li>Klik &ldquo;Proses Pemesanan&rdquo;</li><li>Cek status order mu pada laman &ldquo;Pemesanan.&rdquo;</li></ul>'
              }
            ]
          },
          {
            title: 'Perlengkapan apa saja yang sudah disediakan?',
            content: [
              {
                text:
                  'Vendor Halo Clean sudah menyediakan peralatan sesuai standarisasi dari Halo Jasa terkait perlengkapan kerja.'
              }
            ]
          },
          {
            title: 'Kapan saja jam operasional layanan ini?',
            content: [
              {
                text:
                  'Layanan Halo Clean tersedia mulai pukul 06:00 – 22:00. Anda dapat memesan layanan ini paling cepat satu jam dari waktu anda saat memilih jadwal untuk hari yang sama. Anda juga dapat menjadwalkan pesanan hingga dua hari kedepan.'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Pengaduan Layanan',
    child: [
      {
        title: 'Halo  Massage',
        subdata: [
          {
            title: 'Tidak kunjung mendapatkan vendor',
            content: [
              {
                text:
                  'Jika anda tidak kunjung mendapatkan vendor, anda dapat melakukan order ulang, atau hubungi Customer Care Halo Jasa.'
              }
            ]
          },
          {
            title: 'Pelayanan yang kurang memuaskan',
            content: [
              {
                text:
                  'Kami mohon maaf atas pelayanan yang kurang memuaskan, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang memuaskan. Sertakan pula detail order layanan anda.'
              }
            ]
          },
          {
            title: 'Vendor yang kurang profesional',
            content: [
              {
                text:
                  'Mohon maaf atas kendala yang anda alami, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang professional.Sertakan pula detail order layanan anda.'
              }
            ]
          }
        ]
      },
      {
        title: 'Halo Auto',
        subdata: [
          {
            title: 'Tidak kunjung pendapatkan vendor',
            content: [
              {
                text:
                  'Jika anda tidak kunjung mendapatkan vendor, anda dapat melakukan order ulang, atau hubungi Customer Care Halo Jasa.'
              }
            ]
          },
          {
            title: 'Pelayanan yang kurang memuaskan',
            content: [
              {
                text:
                  'Kami mohon maaf atas pelayanan yang kurang memuaskan, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang memuaskan. Sertakan pula detail order layanan anda.'
              }
            ]
          },
          {
            title: 'Vendor yang kurang profesional',
            content: [
              {
                text:
                  'Mohon maaf atas kendala yang anda alami, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang professional. Sertakan pula detail order layanan anda.'
              }
            ]
          }
        ]
      },
      {
        title: 'Halo Fix',
        subdata: [
          {
            title: 'Tidak kunjung pendapatkan vendor',
            content: [
              {
                text:
                  'Jika anda tidak kunjung mendapatkan vendor, anda dapat melakukan order ulang, atau hubungi Customer Care Halo Jasa.'
              }
            ]
          },
          {
            title: 'Pelayanan yang kurang memuaskan',
            content: [
              {
                text:
                  'Kami mohon maaf atas pelayanan yang kurang memuaskan, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang memuaskan. Sertakan pula detail order layanan anda.'
              }
            ]
          },
          {
            title: 'Kerusakan pada barang',
            content: [
              {
                text:
                  'Terkait kerusakan barang konsumen, anda dapat menghubungi Customer Care Halo Jasa. Sertakan pula detail order dan bukti kerusakan barang.'
              }
            ]
          },
          {
            title: 'Vendor yang kurang profesional',
            content: [
              {
                text:
                  'Mohon maaf atas kendala yang anda alami, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang professional. Sertakan pula detail order layanan anda.'
              }
            ]
          }
        ]
      },
      {
        title: 'Halo Clean',
        subdata: [
          {
            title: 'Tidak kunjung pendapatkan vendor',
            content: [
              {
                text:
                  'Jika anda tidak kunjung mendapatkan vendor, anda dapat melakukan order ulang, atau hubungi Customer Care Halo Jasa.'
              }
            ]
          },
          {
            title: 'Pelayanan yang kurang memuaskan',
            content: [
              {
                text:
                  'Kami mohon maaf atas pelayanan yang kurang memuaskan, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang memuaskan. Sertakan pula detail order layanan anda.'
              }
            ]
          },
          {
            title: 'Kerusakan pada barang',
            content: [
              {
                text:
                  'Terkait kerusakan barang konsumen, anda dapat menghubungi Customer Care Halo Jasa. Sertakan pula detail order dan bukti kerusakan barang.'
              }
            ]
          },
          {
            title: 'Vendor yang kurang profesional',
            content: [
              {
                text:
                  'Mohon maaf atas kendala yang anda alami, mohon hubungi Customer Care Halo Jasa terkait pelayanan yang kurang professional. Sertakan pula detail order layanan anda.'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 4,
    title: 'Kebijakan Privasi',
    child: [
      {
        title: 'Definisi',
        subdata: [
          {
            title: 'Definisi',
            content: [
              {
                text: `
                                        Kebijakan Privasi berikut ini menjelaskan bagaimana kami mengumpulkan, menggunakan, memindahkan, mengungkapkan dan melindungi informasi pribadi anda yang dapat diidentifikasi yang diperoleh melalui Aplikasi kami (sebagaimana didefinisikan di bawah). Mohon anda membaca Kebijakan Privasi ini dengan seksama untuk memastikan bahwa anda memahami bagaimana ketentuan Kebijakan Privasi ini kami berlakukan. Penggunaan anda atas aplikasi dan layanan kami tunduk pada Ketentuan Penggunaan dan Kebijakan Privasi ini dan mengindikasikan persetujuan anda terhadap Ketentuan Penggunaan dan Kebijakan Privasi dibawah ini.
                                        <br /><br />
                                        "Kami" berarti PT Halo Komunikasi Sejahtera dengan salah satu produk Aplikasi dan Situs website bernama Halo Jasa, suatu perusahaan yang didirikan berdasarkan hukum Negara Republik Indonesia.
                                        <br /><br />
                                        "Aplikasi" berarti suatu aplikasi piranti lunak yang telah kami kembangkan yang merupakan suatu sarana untuk menemukan Layanan yang disediakan oleh pihak ketiga.
                                        <br /><br />
                                        "Vendor " berarti suatu pihak ketiga baik perorangan dan berbadan usaha yang pemberi jasa yang menyediakan layanan jasa melalui Aplikasi atau Situs website.
                                        <br /><br />
                                        "Layanan" berarti layanan jasa yang ditawarkan oleh Penyedia Jasa sesuai dengan keahlian masing-masing dibidangnya melalui Aplikasi yang dapat mencakup semua kebutuhan.
                                        <br /><br />
                                        "Informasi Pribadi" berarti informasi mengenai Anda yang secara pribadi dapat diidentifikasi yang dikumpulkan melalui Aplikasi, seperti nama, alamat, tanggal lahir, pekerjaan, nomor telepon, alamat surat elektronik (e-mail) Anda dan/atau sejenisnya, dan informasi lain yang mungkin dapat mengidentifikasi orang tertentu yang sedang menggunakan Aplikasi.
                                        <br /><br />
                                        "Situs web" berarti situs web kami di halojasa.com.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Informasi yang kami kumpulkan',
        subdata: [
          {
            title: 'Informasi yang kami kumpulkan',
            content: [
              {
                text: `
                                        Kami mengumpulkan Informasi Pribadi tertentu dari Anda agar Aplikasi dapat menemukan Layanan Jasa dari Vendor penyedia jasa. Anda akan langsung memberikan Informasi Pribadi (sebagai contoh, saat Anda mendaftar) dan beberapa informasi akan secara otomatis dikumpulkan ketika Anda menggunakan Aplikasi.
                                        <br /><br />
                                        Ketika Anda mengunjungi Situs web kami, administrator situs web kami akan memproses data teknis seperti alamat IP Anda, halaman web yang pernah Anda kunjungi, browser internet yang Anda gunakan, halaman web yang sebelumnya /selanjutnya Anda kunjungi dan durasi setiap kunjungan/sesi yang memungkinkan kami untuk mengirimkan fungsi-fungsi Situs web. Sebagai tambahan, dalam beberapa hal, browser dapat menyarankan Anda agar geo-tagging dan atau geo-location Anda memungkinkan kami untuk memberikan Anda suatu pengalaman yang lebih baik. Dengan data teknis ini administrator-administrator Situs web kami dapat mengelola situs web, misalnya dengan menyelesaikan kesulitan-kesulitan teknis atau memperbaiki kemampuan untuk dapat diaksesnya bagian-baigan tertentu dari situs web. Dengan cara ini, kami dapat memastikan bahwa Anda dapat menemukan informasi pada Situs web dengan cara yang cepat dan sederhana.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Informasi yang anda berikan secara langsung',
        subdata: [
          {
            title: 'Informasi yang anda berikan secara langsung',
            content: [
              {
                text: `
                                        Pada saat mendaftar pada Aplikasi, Anda akan memberikan kepada kami alamat surat elektronik / surel (email), nama, nomor telepon, dan sandi akun Anda.
                                        <br /><br />
                                        Ketika Anda menggunakan Aplikasi untuk menemukan suatu layanan jasa, Anda memberikan informasi pada kami, yaitu lokasi dan bidang jasa yang Anda inginkan. Anda juga memberikan informasi kepada kami mengenai jasa yang Anda butuhkan. Ketika Anda menggunakan Aplikasi kami, kami juga akan memproses data teknis Anda seperti alamat IP, Identitas (ID) Perangkat atau alamat MAC, dan informasi mengenai pabrikan, model, dan sistem operasi dari perangkat bergerak/mobile device Anda. Kami menggunakan data ini untuk memungkinkan kami untuk mengirimkan fungsi-fungsi dari Aplikasi, menyelesaikan kesulitan-kesulitan teknis, menyediakan bagi Anda versi Aplikasi yang benar dan terkini dan untuk meningkatkan fungsi Aplikasi.
                                        <br /><br />
                                        Kami akan meminta nomor telepon seseorang yang dapat dihubungi oleh Vendor Penyedia Jasa untuk melengkapi pesanan jasa Anda ketika Anda menggunakan Aplikasi untuk menemukan suatu layanan jasa. Anda harus mendapatkan persetujuan terlebih dahulu dari orang yang nomor teleponnya Anda berikan pada kami untuk memberikan nomor teleponnya pada kami dan untuk kami memberikan nomor telepon tersebut kepada Vendor.
                                        <br /><br />
                                        Ketika Anda mengisi ulang (TOP UP) Dompet -Credit dan mengunakan fasilitas Dompet- Tunai untuk penarikan transaksi anda, Maka kami akan mengumpulkan informasi seperti nama bank dimana rekening Anda dibuka, nama pemegang rekening, dan jumlah yang Anda transfer untuk pengisian ulang (TOP UP). Jika Anda melakukan pengisian ulang melalui fasilitas lain data tersebut akan kami simpan untuk kepentingan pencatatan perusahaan.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Informasi yang kami kumpulkan saat menggunakan aplikasi',
        subdata: [
          {
            title: 'Informasi yang kami kumpulkan saat menggunakan aplikasi',
            content: [
              {
                text: `
                                        Ketika Anda menggunakan Aplikasi melalui perangkat bergerak / mobile device Anda, kami akan melacak dan mengumpulkan informasi geo-location secara real-time. Kami juga dapat menggunakan informasi geo-location secara real-time ini untuk memberikan bantuan, menyelesaikan kesulitan-kesulitan teknis atau usaha yang mungkin timbul pada saat Anda menggunakan Aplikasi. Anda dapat mematikan informasi pelacak geo-location pada tingkatan perangkat untuk sementara waktu. Perangkat bergerak/mobile Anda akan memberitahukan Anda ketika geo-location Anda dilacak dengan menampilkan simbol panah GPS.
                                        <br /><br />
                                        Kami juga melacak dan mengumpulkan informasi geo-location Vendor Penyedia Jasa. Ini berarti bahwa kami juga mengumpulkan informasi ketika Anda bepergian dengan Vendor Penyedia Jasa. Kami juga akan menggunakan informasi geo-location Vendor Penyedia Jasa dalam bentuk tanpa nama dan keseluruhan untuk mendapatkan informasi statistic dan informasi pengelolaan dan untuk menyediakan untuk Anda fungsi Aplikasi yang ditingkatkan.
                                        <br /><br />
                                        Namun geo-location tidak dapat digunakan oleh Vendor Penyedia Jasa maupun Pengguna Layanan untuk menjamin keamanan kedua belah pihak. Hal ini hanya sebagai bentuk pertanggung jawaban kami dan/atau sebagai bukti untuk diserahkan kepada pihak yang berwajib untuk mengatasi hal-hal yang tidak diinginkan.
                                        <br /><br />
                                        Ketika anda menggunakan dan/atau ketika pembayaran atau transfer dilakukan melalui fasilitas uang elektronik dan/atau dompet elektronik yang disediakan oleh kami, kami dapat mengumpulkan informasi tertentu terkait dengan sumber dana yang anda gunakan untuk melakukan isi ulang (termasuk rincian rekening bank), rincian rekening penerima penarikan, riwayat transaksi (termasuk detail penerima), rincian tagihan, faktur, dan nomor telepon.
                                        <br /><br />
                                        Ketika anda menggunakan dan memanfaatkan  akun virtual yang disediakan oleh kami untuk menerima pembayaran menggunakan uang elektronik dan/atau dompet elektronik dari pembayar, baik anda merupakan user penguna, dan vendor layanan jasa yang bekerja sama, kami dapat mengumpulkan informasi tertentu yang terkait dengan penggunaan anda termasuk tetapi tidak terbatas pada layanan dan/atau barang yang ditransaksikan, 
                                        <br /><br />
                                        Jumlah yang anda kumpulkan dari setiap transaksi, rincian akun penarikan atau penyelesaian pembayaran dan riwayat penarikan atau penyelesaian pembayaran.
                                        <br /><br />
                                        Anda dengan ini setuju bahwa aplikasi kami akan digunakan untuk berkomunikasi dengan anda dan mengirimkan anda informasi sehubungan dengan penggunaan aplikasi dan data Anda akan digunakan oleh pemrosesan data internal kami untuk memberikan Layanan yang lebih baik kepada Anda.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Penggunaan Informasi yang kami kumpulkan',
        subdata: [
          {
            title: 'Penggunaan Informasi yang kami kumpulkan',
            content: [
              {
                text: `
                                        Kami menggunakan surel, nama, nomor telepon, dan sandi akun Anda untuk memverifikasi kepemilikan Anda atas suatu akun, untuk berkomunikasi dengan Anda sehubungan dengan pesanan Anda dan untuk memberikan Anda informasi mengenai Aplikasi. Kami juga dapat menggunakan nama, surel, dan nomor telepon Anda untuk mengirimkan pesan, pembaharuan yang bersifat umum atas Aplikasi, penawaran-penawaran khusus atau promosi-promosi. Kami juga akan mengirimkan surel kepada Anda yang meminta Anda untuk berlangganan Daftar Surat Menyurat (Mailing List) kami. Anda dapat setiap saat memilih untuk tidak menerima informasi mengenai pembahrauan ini.
                                        <br /><br />
                                        Kami menggunakan informasi seperti jasa yang Anda butuhkan dan/atau beli untuk menentukan apakah Aplikasi dapat menerima pesanan Anda berdasarkan Ketentuan Penggunaan.
                                        Kami menggunakan informasi seperti nama bank dimana rekening Anda dibuat, nama dimana rekening tersebut disimpan dan jumlah yang ditransfer untuk isi ulang (TOP UP) untuk memastikan pembayaran yang Anda lakukan untuk bertransaksi.
                                        <br /><br />
                                        Kami menggunakan Informasi Pribadi dalam bentuk tanpa nama dan secara keseluruhan untuk memantau lebih dekat fitur-fitur mana dari Layanan yang paling sering digunakan, untuk menganalisa pola penggunaan dan untuk menentukan apakah kami akan menawarkan atau fokus pada Layanan kami. 
                                        <br /><br />
                                        kami mengunakan informasi anda untuk memantau dan menganalisis aktivitas, perilaku, dan data demografis pengguna termasuk kebiasaan dan penggunaan berbagai layanan yang tersedia di Aplikasi;
                                        Kami akan mengunakan dan memproses serta mengelola reward points anda dan memungkinakan mengirimkan anda komunikasi pemasaran, iklan, voucher, survei, dan informasi secara langsung atau terfokus, dan informasi tentang penawaran atau promosi khusus.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Pemberian informasi yang kami kumpulkan',
        subdata: [
          {
            title: 'Pemberian informasi yang kami kumpulkan',
            content: [
              {
                text: `
                                        Kami dapat mempekerjakan perusahaan-perusahaan dan orang perorangan pihak ketiga untuk memfasilitasi atau memberikan Aplikasi dan layanan-layanan tertentu atas nama kami, untuk memberikan bantuan konsumen, memberikan informasi geo-location kepada Vendor Penyedia Jasa kami, untuk melaksanakan layanan-layanan terkait dengan Situs web (misalnya tanpa pembatasan, layanan pemeliharaan, pengelolaan database, analisis web dan penyempurnaan fitur-fitur Situs web dan juga aplikasi mobile kami) atau untuk membantu kami dalam menganalisa bagaimana Layanan kami digunakan atau untuk penasihat profesional dan auditor eksternal kami, termasuk penasihat hukum, penasihat keuangan, dan konsultan-konsultan. Para pihak ketiga ini hanya memiliki akses atas informasi pribadi Anda untuk melakukan tugas-tugas tersebut atas nama kami dan secara kontraktual terikat untuk tidak mengungkapkan atau menggunakan informasi pribadi tersebut untuk tujuan lain apapun.
                                        <br /><br />
                                        Kami tidak membagikan Informasi Pribadi Anda kepada pihak manapun selain kepada Vendor Penyedia Jasa terkait dan perusahaan dan individu pihak ketiga yang disebutkan di atas, tanpa persetujuan dari Anda. Namun demikian, kami akan mengungkapkan Informasi Pribadi Anda sepanjang dimintakan secara hukum, atau diperlukan untuk tunduk pada ketentuan perundang-undangan, peraturan-peraturan dan pemerintah, atau dalam hal terjadi sengketa, atau segala bentuk proses hukum antara Anda dan kami, atau antara Anda dan pengguna lain sehubungan dengan, atau terkait dengan Layanan, atau dalam keadaan darurat yang berkaitan dengan kenyamanan dan/atau keselamatan Anda.
                                        <br /><br />
                                        Informasi Pribadi Anda dapat dialihkan, disimpan, digunakan, dan diproses di suatu yurisdiksi selain Indonesia dimana server-server kami berada. Anda memahami dan setuju atas pengalihan Informasi Pribadi Anda ke luar Indonesia.
                                        Kami tidak menjual atau menyewakan Informasi Pribadi Anda kepada pihak ketiga. Kami akan menahan informasi Anda hingga Anda menghapus akun Anda pada Aplikasi.
                                        <br /><br />
                                        Kami tidak akan bertanggung jawab atas penyimpanan Informasi Pribadi anda. Anda setuju untuk mengganti rugi, membela, dan membebaskan kami, pejabat, direktur, karyawan, vendor, mitra,dan afiliasi kami dari dan terhadap setiap dan segala klaim, kerugian, kewajiban, biaya, kerusakan, dan ongkos (termasuk tetapi tidak terbatas pada biaya hukum dan pengeluaran biaya ganti rugi penuh) yang dihasilkan secara langsung atau tidak langsung dari setiap penyimpanan yang tidak sah atas Informasi Pribadi anda.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Keamanan',
        subdata: [
          {
            title: 'Keamanan',
            content: [
              {
                text: `
                                        Kami tidak menjamin keamanan database kami dan kami juga tidak menjamin bahwa data yang Anda berikan tidak akan ditahan/terganggu ketika sedang dikirimkan kepada kami. Setiap pengiriman informasi oleh Anda kepada kami merupakan risiko Anda sendiri. Anda tidak boleh mengungkapkan sandi Anda kepada siapapun. Bagaimanapun efektifnya suatu teknologi, tidak ada sistem keamanan yang tidak dapat ditembus.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Perubahan kebijakan privasi',
        subdata: [
          {
            title: 'Perubahan kebijakan privasi',
            content: [
              {
                text: `
                                        Kami dapat mengubah Kebijakan Privasi ini untuk mencerminkan perubahan dalam kegiatan kami. Jika kami mengubah Kebijakan Privasi ini, kami akan memberitahu Anda melalui email atau dengan cara pemberitahuan di Situs web 1 hari sebelum perubahan berlaku. Kami menghimbau Anda untuk meninjau halaman ini secara berkala untuk mengetahui informasi terbaru tentang bagaimana ketentuan Kebijakan Privasi ini kami berlakukan.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Lain lain',
        subdata: [
          {
            title: 'Lain lain',
            content: [
              {
                text: `
                                        Bahasa. Kebijakan Privasi ini dibuat dalam bahasa Inggris dan bahasa Indonesia, versi keduanya akan mengikat Anda dan kami. Jika terdapat ketidaksesuaian antara versi bahasa Indonesia dan versi bahasa Inggris, maka versi bahasa Indonesia yang akan berlaku.
                                        <br /><br />
                                        Hukum yang mengatur dan yurisdiksi. Kebijakan Privasi ini diatur oleh dan untuk ditafsirkan dalam hukum Negara Republik Indonesia. Setiap dan seluruh sengketa yang timbul dari kebijakan privasi ini akan diatur oleh yurisdiksi eksklusif dari Pengadilan Negeri Jakarta Selatan.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Pengakuan dan persetujuan',
        subdata: [
          {
            title: 'Pengakuan dan persetujuan',
            content: [
              {
                text: `
                                        Dengan menggunakan Aplikasi, Anda mengakui bahwa Anda telah membaca dan memahami Kebijakan Privasi ini dan Ketentuan Penggunaan dan setuju dan sepakat terhadap penggunaan, praktek, pemrosesan dan pengalihan informasi pribadi Anda oleh kami sebagaimana dinyatakan di dalam Kebijakan Privasi ini.
                                        <br /><br />
                                        Anda juga menyatakan bahwa Anda memiliki hak untuk membagikan seluruh informasi yang telah Anda berikan kepada kami dan untuk memberikan hak kepada kami untuk menggunakan dan membagikan informasi tersebut kepada Vendor Penyedia Jasa.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Menerima dan memberhentikan layanan promosi',
        subdata: [
          {
            title: 'Menerima dan memberhentikan layanan promosi',
            content: [
              {
                text: `
                                        Kami dapat mengirimkan anda pemasaran langsung, iklan, dan komunikasi promosi melalui aplikasi push-notification,pesan melalui Aplikasi, panggilan telepon, layanan pesan singkat (SMS), dan email (“Materi Pemasaran”) jika anda telah setuju untuk berlangganan milis kami, dan/atau setuju untuk menerima materi pemasaran dan promosi dari kami,Jika Anda ingin berhenti menerima email dari kami, silahkan klik link unsubscribe yang disertakan pada masing-masing e-mail. Atau menghubungi kami di detail kontak tercantum dibawah ini.
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Cara menghubungi kami',
        subdata: [
          {
            title: 'Cara menghubungi kami',
            content: [
              {
                text: `
                                        Jika Anda memiliki pertanyaan lebih lanjut tentang privasi dan keamanan informasi Anda dan ingin memperbarui atau menghapus data Anda maka silakan hubungi kami di: support@halojasa.co.id
                                        `
              }
            ]
          }
        ]
      },
      {
        title: 'Cara menghapus akun',
        subdata: [
          {
            title: 'Cara menghapus akun',
            content: [
              {
                text: `
                                        Jika Anda ingin menghapus akun Anda, silakan buka aplikasi Halo Jasa, lalu klik menu “Pengaturan” dan pilih “Hapus Akun”. Setelah itu, ikuti langkah-langkah yang ada pada aplikasi.`}

            ]
          }

        ]
      },
      {
        id: 5,
        title: 'Syarat Umum',
        child: [
          {
            title: 'Perihal umum',
            subdata: [
              {
                title: 'Perihal umum',
                content: [
                  {
                    text: `
                                        Dengan mengunduh, menginstall, dan/atau menggunakan Aplikasi Halo Jasa (“Aplikasi”), anda menyetujui bahwa anda telah membaca, memahami, dan menerima Ketentuan penggunaan ini (“Ketentuan Penggunaan”). Ketentuan Penggunaan ini merupakan suatu perjanjian sah antara anda dan PT.Halo Komunikasi Sejahtera dan layanan Halo Jasa (sebagaimana didefinisikan di bawah ini) Berlaku pada kunjungan dan penggunaan anda pada situs web kami dihalojasa.com (“Situs Web”). <br /><br />
                                        Silahkan membatalkan akun anda (jika anda telah mendaftar untuk aplikasi) dan secara permanen menghapus aplikasi dari perangkat anda jika anda tidak setuju atau tidak ingin masuk ke dalam Ketentuan Penggunaan. <br /><br />
                                        MOHON ANDA MEMERIKSA KETENTUAN PENGGUNAAN DAN KEBIJAKAN PRIVASI KAMI DENGAN SEKSAMA SEBELUM MENGUNDUH DAN/ATAU MENGGUNAKAN APLIKASI DAN SITUS WEBSITE KAMI UNTUK PERTAMA KALI. <br /><br />
                                        PT. Halo Komunikasi Sejahtera adalah suatu perseroan yang didirikan berdasarkan hukum Negara Republik Indonesia (“kami atau “milik kami”).<br /><br />
                                        Aplikasi ini merupakan aplikasi perangkat lunak yang berfungsi sebagai sarana untuk menemukan layanan berbagai macam jenis jasa yang disediakan oleh pihak Vendor penyedia jasa. Jenis layanan yang dapat diminta melalui aplikasi dan/atau website adalah semua yang tertera didalam kategori aplikasi dan/atau website kami. Kami dapat menambahkan atau mengurangi jenis kategori pada aplikasi dan/atau website kami dari waktu ke waktu. <br /><br />
                                        Anda memiliki kebebasan penuh dalam menggunakan Aplikasi Halo Jasa atau aplikasi lain, Semua Layanan disediakan secara langsung oleh pihak ketiga independen yang setuju menjadi vendor penyedia layanan Kami dengan skema kemitraan atau skema lainnya “ Vendor Penyedia Layanan” <br /><br />
                                        Ketika Anda melakukan pemesanan, Aplikasi Halo jasa akan menyambungkan pemesanan Anda dengan Penyedia Layanan yang saat itu tersedia di sekitar lokasi Anda, dengan demikian agar dapat melakukan order pada Layanan yang tersedia anda memerlukan untuk mengaktifkan fitur penentuan lokasi pada perangkat anda, selanjutnya, jika Vendor Penyedia Jasa menerima pesanan Anda, Kami akan menginformasikan status pesanan Anda melalui sistem perangkat Aplikasi Halo Jasa. <br /><br />
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Ketentuan penggunaan aplikasi',
            subdata: [
              {
                title: 'Ketentuan penggunaan aplikasi',
                content: [
                  {
                    text: `
                                        Anda menyatakan dan menjamin bahwa Anda adalah individu yang secara hukum berhak untuk mengadakan perjanjian yang mengikat berdasarkan hukum Negara Republik Indonesia. khususnya Ketentuan Penggunaan, untuk menggunakan Aplikasi dan bahwa Anda telah berusia minimal 13 tahun sesuai dengan Undang-Undang ketenagakerjaan pasal 68 dan pasal 69 UU No. 13 Tahun 2003 bahwa untuk anak yang berumur antara 13 sampai dengan 15 tahun harus mendapat izin tertulis dari orang tua/wali dan tidak mengganggu dan harus dijaga perkembangan kesehatan, fisik, dan mental serta hubungan sosial anak tersebut. Untuk anak yang berumur antara 15 sampai dengan 18 tahun sudah dapat dipekerjakan secara umum namun khususnya pekerjaan yang tidak mengandung unsur bahaya. Apabila usia anak telah 18 tahun, ia sudah dapat bekerja secara umum dan normal sesuai dengan kualifikasi dan kompetensi kerja atau profesi yang ia miliki. <br /><br />
                                        Pencari Jasa harus menyetujui dan menerima segala ketentuan-ketentuan yang bersangkutan dalam hubunganya pada pasal tersebut. Jika tidak, kami atau Penyedia Jasa terkait, berhak berdasarkan hukum untuk membatalkan perjanjian yang dibuat dengan Anda. Anda selanjutnya menyatakan dan menjamin bahwa Anda memiliki hak, wewenang dan kapasitas untuk menggunakan Layanan dan mematuhi Ketentuan Penggunaan. Jika Anda mendaftarkan atas nama suatu badan hukum, Anda juga menyatakan dan menjamin bahwa Anda berwenang untuk mengadakan, dan mengikatkan diri entitas tersebut pada Ketentuan Penggunaan ini dan mendaftarkan untuk Layanan dan Aplikasi dan atau situs website. Kami mengumpulkan dan memproses informasi pribadi Anda, seperti nama, alamat/domisili, alamat surat elektronik (surel / e-mail), foto, dan nomor telepon seluler Anda ketika Anda mendaftar. Anda harus memberikan informasi yang akurat dan lengkap, memperbaharui informasi dan setuju untuk memberikan kepada kami bukti identitas apapun yang secara wajar dapat kami mintakan. Jika informasi pribadi yang Anda berikan kepada kami ada yang berubah, misalnya, jika Anda mengubah alamat surel, nomor telepon, mohon perbaharui rincian informasi Anda dengan mengirimkan permintaan Anda kepada kami. Kami akan memberlakukan perubahan yang diminta tersebut dalam waktu lima belas (15) hari kerja sejak diterimanya pemberitahuan perubahan. <br /><br />
                                        Anda hanya dapat menggunakan Aplikasi dan Situs Website ketika Anda telah mendaftar pada Aplikasi dan Situs Website tersebut. Setelah Anda berhasil mendaftarkan diri, Aplikasi akan memberikan Anda suatu akun pribadi yang dapat diakses dengan kata sandi yang Anda pilih. <br /><br />
                                        Hanya Anda yang dapat menggunakan akun Anda sendiri dan Anda berjanji untuk tidak memberikan wewenang kepada orang lain untuk menggunakan identitas Anda atau menggunakan akun Anda. Anda tidak dapat menyerahkan atau mengalihkan akun Anda kepada pihak lain. Anda harus menjaga keamanan dan kerahasiaan kata sandi akun Anda dan setiap identifikasi yang kami berikan kepada Anda. Dalam hal terjadi pengungkapan atas kata sandi Anda, dengan cara apapun, yang mengakibatkan setiap penggunaan yang tidak sah atau tanpa kewenangan atas akun atau identitas Anda, pesanan yang diterima dari penggunaan yang tidak sah atau tanpa kewenangan tersebut masih akan dianggap sebagai pesanan yang sah, kecuali Anda memberitahu kami tentang mengenai hal tersebut sebelum Penyedia Jasa memberikan Layanan yang diminta. <br /><br />
                                        Anda hanya dapat memiliki satu akun Halo Jasa baik  Vendor Penyedia Jasa maupun Pencari Jasa. <br /><br />
                                        Informasi yang diberikan oleh Aplikasi tidak dapat diartikan sebagai suatu saran atau penawaran, keputusan untuk menggunakan Vendor Penyedia Jasa sepenuhnya berada di tangan Anda. Anda bebas untuk memilih untuk menggunakan Vendor Penyedia Jasa lainnya. <br /><br />
                                        Anda berjanji bahwa Anda akan menggunakan Aplikasi hanya untuk tujuan yang dimaksud untuk mendapatkan Layanan. Anda tidak diperbolehkan untuk menyalah gunakan atau menggunakan Aplikasi untuk tujuan penipuan atau menyebabkan ketidaknyamanan kepada orang lain atau melakukan pemesanan palsu. <br /><br />
                                        Jika Anda juga adalah seorang vendor Penyedia Jasa, Anda tidak dapat menggunakan akun konsumen Anda sendiri (atau akun milik konsumen orang lain) untuk melakukan pemesanan yang akan Anda terima sendiri sebagai seorang vendor penyedia jasa. <br /><br />
                                        Anda tidak diperkenankan untuk membahayakan, mengubah atau memodifikasi Aplikasi dan/atau Situs web atau mencoba untuk membahayakan, mengubah atau memodifikasi Aplikasi dan/atau Situs web dengan cara apapun. Kami tidak bertanggung jawab jika Anda tidak memiliki perangkat yang sesuai atau jika Anda telah mengunduh versi Aplikasi yang salah untuk perangkat Anda. Kami berhak untuk melarang Anda untuk menggunakan Aplikasi lebih lanjut jika Anda menggunakan Aplikasi dengan perangkat yang tidak kompatibel/cocok atau tidak sah atau untuk tujuan lain selain daripada tujuan yang dimaksud untuk penggunaan Aplikasi ini. Anda berjanji bahwa Anda hanya akan menggunakan suatu jalur akses yang diperbolehkan untuk Anda gunakan. <br /><br />
                                        Anda akan menjaga kerahasiaan dan tidak akan menyalahgunakan informasi yang Anda terima dari penggunaan Aplikasi tersebut. Anda akan memperlakukan Vendor Penyedia Jasa dengan hormat dan tidak akan terlibat dalam perilaku atau tindakan yang tidak sah, mengancam atau melecehkan ketika menggunakan layanan mereka. <br /><br />
                                        Anda memahami dan setuju bahwa penggunaan Aplikasi oleh Anda akan tunduk pula pada Kebijakan Privasi kami sebagaimana dapat diubah dari waktu ke waktu. Dengan menggunakan Aplikasi, Anda juga memberikan persetujuan sebagaimana dipersyaratkan berdasarkan Kebijakan Privasi kami. <br /><br />
                                        Dengan memberikan informasi kepada kami, Anda menyatakan bahwa Anda berhak untuk memberikan kepada kami informasi yang akan kami gunakan dan berikan kepada Vendor Penyedia Jasa. <br /><br />
                                        Aplikasi tidak boleh dipergunakan untuk mencari Layanan Jasa untuk hal yang ilegal seperti: Perjudian, Prostitusi, maupun hal-hal yang melanggar hukum dan undang-undang yang berlaku di Negara Republik Indonesia. <br /><br />
                                        Penyedia Jasa berhak untuk menolak pesanan Anda jika menurut penilaian pribadi Penyedia Jasa, ia mungkin tidak dapat melakukan permintaan pemesanan. <br /><br />
                                        Kami dan/atau Penyedia Jasa yang terkait berhak menolak untuk menerima pesanan jasa Anda jika kami memiliki alasan yang wajar untuk mencurigai bahwa Anda telah, atau dengan menerima pesanan dari Anda, Anda akan melanggar Ketentuan Penggunaan ini atau hukum dan peraturan perundang-undangan yang berlaku. <br /><br />
                                        Kami dapat, berdasarkan kebijakan kami, memberikan promosi-promosi yang dapat ditukar untuk manfaat terkait dengan penggunaan Aplikasi. Anda setuju bahwa Anda hanya akan menggunakan promosi tersebut sebagaimana promosi tersebut dimaksudkan dan tidak akan menyalahgunakan, menggAndakan, menjual atau mengalihkan promosi tersebut dengan cara apapun. Anda juga memahami bahwa promosi tidak dapat ditukarkan dengan uang tunai dan dapat berakhir pada tanggal tertentu, bahkan sebelum Anda menggunakannya. <br /><br />
                                        Anda setuju dan mengakui bahwa Anda akan membayar sesuai dengan tanda terima yang diterbitkan oleh Vendor Penyedia Jasa kepada Anda<br /><br />
                                        Mohon menginformasikan kepada kami jika Anda tidak lagi memiliki kontrol atas akun Anda, sebagai contoh akun Anda dengan cara bagaimanapun diretas (hack) atau telepon Anda dicuri, sehingga kami dapat membatalkan akun Anda dengan sebagaimana mestinya. Mohon diperhatikan bahwa Anda bertanggung jawab atas penggunaan akun Anda dan Anda mungkin dapat dimintakan tanggung jawabnya meskipun jika akun Anda tersebut disalahgunakan oleh orang lain
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Pembayaran',
            subdata: [
              {
                title: 'Pembayaran',
                content: [
                  {
                    text: `
                                        Pengunduhan dan/atau penggunaan Aplikasi ini adalah bebas biaya. Kami dapat memperkenalkan pengenaan biaya untuk pengunduhan dan/atau penggunaan Aplikasi di setiap saat. Kami akan memberitahu Anda tentang hal ini sebagaimana mestinya agar Anda dapat memutuskan apakah Anda ingin terus menggunakan Aplikasi tersebut atau tidak. Namun demikian, koneksi internet yang dibutuhkan untuk menggunakan Layanan, dan setiap biaya terkait (misalnya biaya data ponsel) yang ditimbulkan oleh penggunaan Layanan tersebut adalah tanggung jawab eksklusif Anda dan semata-mata dibebankan kepada Anda. <br /><br />
                                        Tarif yang berlaku untuk Layanan oleh Penyedia Jasa dapat ditemukan pada Situs dan melalui Aplikasi. Tarif dapat dirubah atau diperbaharui oleh HALO JASA dan Vendor Penyedia Jasa yang bekerja sama dari waktu ke waktu. Anda setuju bahwa Anda akan membayar Layanan yang diberikan kepada Anda oleh Penyedia Jasa secara penuh. <br /><br />
                                        Untuk menjamin keamanan dan kenyamanan kedua belah pihak kami menggunakan layanan E-Wallet dalam bentuk yang telah disediakan oleh Halo Jasa yang bekerja sama oleh pihak ketiga. <br /><br />
                                        Dalam proces transaksi yang disediakan dalam layanan kami pembayaran dapat dilakukan dengan cara mengisi (TOP-UP) pada pihak ketiga seperti Dana Digital Indonesia dan Ovo Payment sistem yang telah bekerja sama <br /><br />
                                        Proces transaksi dan pembayaran dapat dilakukan menggunakan kartu kredit, bank transfer dan fasilitas lainnya yang diberikan oleh payment gateway dari pihak ke tiga yang telah bekerja sama. <br /><br />
                                        Dompet Credit dapat digunakan disemua fasilitas aplikasi dan/atau website HALO JASA yang berupa pembelian credit. untuk pengisian (Top-UP) bagi para Vendor Penyedia Jasa untuk dapat mengaktifkan layanan order masuk yang dapat diterima oleh Vendor Penyedia Jasa. <br /><br />
                                        Penyedia Jasa menyetujui peraturan pemotongan dari setiap transaksi yang dilakukan oleh Penyedia Jasa kepada Pencari jasa. perhitungan presentasi fee memiliki perhitungan berbeda berdasarkan katagorie katagorie layanan yang dimiliki, informasi marketing fee hanya dikenakan kepada setiap penyedia jasa yang memiliki transaksi berhasil, terkait peraturan penyedia jasa, HALO JASA dari waktu ke waktu dapat merubah besar persenan potongan terhadap Penyedia Jasa. <br /><br />
                                        HALO JASA menghimbau Vendor Penyedia Jasa untuk melaporkan dan membayar pajak penghasilan sesuai dengan ketentuan pajak Negara Republik Indonesia. Halo Jasa tidak berkewajiban membantu proses pembayaran pajak penghasilan Penyedia Jasa. <br /><br />
                                        Ketika Anda menggunakan layanan E-Wallet yang bekerja sama dengan HALO JASA sebagai alat pembayaran atas produk-produk/ layanan terdapat pada APLIKASI Halo Jasa., Anda dengan ini mengakui dan setuju untuk memberikan kami kuasa dan kewenangan penuh untuk memotong E-Wallet Anda dan mentransfer uang atas nama Anda untuk membayar  fitur-fitur yang terdapat pada Halo Jasa
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Tanggung jawab kami',
            subdata: [
              {
                title: 'Tanggung jawab kami',
                content: [
                  {
                    text: `
                                        Kami tidak bertanggung jawab atas setiap kehilangan, kematian, kerusakan atau kerugian yang disebabkan oleh perilaku dari para Penyedia Jasa. Kami juga tidak bertanggung jawab atas kesalahan dan/atau tindakan kriminal yang dilakukan oleh Vendor Penyedia Jasa selama pelaksanaan Layanan. Vendor Penyedia Jasa hanya merupakan mitra kerja kami, bukan pegawai, agen atau perwakilan kami. <br /><br />
                                        Namun, kami peduli akan kenyamanan, kepuasan dan keselamatan pengguna Aplikasi atas pertimbangan pribadi semata dan sepenuhnya, kami bersedia untuk memberikan bantuan berupa informasi yang dibutuhkan untuk pihak yang berwajib jika Vendor Penyedia Jasa melanggar hukum dan perundangan-undangan yang berlaku. Mohon mengingatkan Vendor Penyedia Jasa jika Anda merasa tidak nyaman dengan cara Vendor Penyedia Jasa menyediakan Layanan Jasa. <br /><br />
                                        Kami tidak memiliki asuransi untuk barang ataupun jiwa kepada Vendor Penyedia Jasa dan Pengguna Jasa dan oleh karena itu jika Anda merasa hal tersebut diasuransikan selama proses layanan berlangsung, silakan Anda menghubungi penyedia asuransi Anda. <br /><br />
                                        Kami menggunakan cara-cara teknis dan keamanan yang tepat dan wajar untuk menjaga Aplikasi aman dan terbebas dari virus dan kesalahan. Namun demikian, bagaimanapun efektifnya teknologi ini, tidak ada sistem keamanan yang tidak dapat ditembus. Oleh karena itu kami tidak dapat menjamin keamanan database kami dan kami juga tidak dapat menjamin bahwa informasi yang Anda berikan tidak akan ditahan/terganggu saat sedang dikirimkan kepada kami. <br /><br />
                                        Aplikasi ini dapat mengalami keterbatasan, penundaan, dan masalah-masalah lain yang terdapat dalam penggunaan internet dan komunikasi elektronik, termasuk perangkat yang digunakan oleh Anda atau Vendor Penyedia Jasa rusak, tidak terhubung, berada di luar jangkauan, dimatikan atau tidak berfungsi. Kami tidak bertanggung jawab atas keterlambatan, kegagalan pengiriman, kerusakan atau kerugian yang diakibatkan oleh masalah-masalah tersebut. 
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Pembatasan tanggung jawab',
            subdata: [
              {
                title: 'Pembatasan tanggung jawab',
                content: [
                  {
                    text: `
                                        Setiap tuntutan terhadap kami dalam hal apapun oleh Anda, akan dibatasi dengan jumlah total yang sebenarnya dibayar oleh dan/atau terhutang pada Anda ketika menggunakan Layanan selama peristiwa yang menimbulkan klaim tersebut. Dalam hal apapun kami dan/atau pemberi lisensi kami tidak akan bertanggung jawab kepada Anda atau siapa pun atas biaya, bunga, kerusakan atau kerugian dalam segala jenis atau bentuk(termasuk cidera pribadi, gangguan emosi dan hilangnya data, barang, pendapatan, keuntungan, penggunaan atau keuntungan ekonomi lainnya). <br /><br />
                                        Perusahaan dan/atau pemberi lisensinya tidak akan bertanggung jawab atas kerugian, kerusakan atau cidera yang mungkin ditimbulkan oleh atau disebabkan oleh Anda atau pada setiap orang untuk siapa Anda telah memesan Layanan, termasuk namun tidak terbatas pada kerugian, kerusakan atau cidera yang timbul dari, atau dengan cara apapun sehubungan dengan Layanan dan/atau Aplikasi, termasuk namun tidak terbatas pada penggunaan atau ketidakmampuan untuk menggunakan Layanan dan/atau Aplikasi. <br /><br />
                                        Anda secara tegas mengesampingkan dan melepaskan kami dari setiap dan semua kewajiban, tuntutan atau kerusakan yang timbul dari atau dengan cara apapun sehubungan dengan Vendor Penyedia Jasa. Perusahaan tidak akan menjadi pihak dalam sengketa, negosiasi sengketa antara Anda dan Vendor Penyedia Jasa. Tanggung jawab untuk keputusan yang Anda buat atas Layanan yang ditemukan melalui Aplikasi merupakan tanggung jawab dan melekat seutuhnya dengan dan pada Anda. Anda secara tegas mengesampingkan dan melepaskan kami dari setiap dan semua kewajiban, tuntutan, penyebab tindakan, atau kerusakan yang timbul dari penggunaan Layanan, perangkat lunak dan/atau Aplikasi, atau dengan cara apapun terkait dengan Vendor Penyedia Jasa yang diperkenalkan kepada Anda melalui Aplikasi. <br /><br />
                                        Kualitas Layanan yang diperoleh melalui penggunaan Aplikasi ini sepenuhnya menjadi tanggung jawab Vendor Penyedia Jasa yang pada akhirnya memberikan Layanan untuk Anda. Anda memahami, oleh karena itu, bahwa dengan menggunakan Aplikasi ini, Anda dapat dihadapkan pada semua Layanan Jasa yang berpotensi berbahaya, ofensif, berbahaya bagi anak di bawah umur, tidak aman atau tidak pantas, dan bahwa Anda menggunakan layanan atas risiko Anda sendiri.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Jaminan',
            subdata: [
              {
                title: 'Jaminan',
                content: [
                  {
                    text: `
                                        Data sejarah dalam aplikasi dan/atau situs website akan disimpan selama 30 hari pada database server kami untuk mempermudah pelacakan dalam urusan kepolisian dan pelanggaran Undang-Undang Negara Republik Indonesia. <br /><br />
                                        Kami tidak memberikan pernyataan, jaminan atau garansi untuk dapat diandalkannya, ketepatan waktu, kualitas, kesesuaian, ketersediaan, akurasi atau kelengkapan dari Layanan, Situs web dan/atau perangkat lunak Aplikasi, termasuk namun tidak terbatas pada Layanan yang diperoleh atau berasal dari Penyedia Jasa melalui penggunaan Aplikasi dan/atau situs website tersebut. Kami tidak menyatakan atau menjamin bahwa (a) penggunaan Layanan dan/atau Aplikasi akan aman, tepat waktu, tanpa gangguan atau terbebas dari kesalahan atau beroperasi dengan kombinasi dengan perangkat keras lain, perangkat lunak, sistem atau data, (b) Layanan akan memenuhi kebutuhan atau harapan Anda, (c) setiap data yang tersimpan akan akurat atau dapat diAndalkan, (d) kualitas produk, layanan, informasi, atau bahan-bahan lain yang dibeli atau diperoleh oleh Anda melalui Aplikasi akan memenuhi kebutuhan atau harapan Anda, (e) kesalahan atau kecacatan dalam Aplikasi akan diperbaiki, atau (f) aplikasi atau server(-server)) yang menyediakan Aplikasi terbebas dari virus atau komponen berbahaya lainnya. Layanan disediakan untuk Anda terbatas hanya pada dasar "sebagaimana adanya". Semua kondisi, pernyataan dan jaminan, baik tersurat, tersirat, yang diwajibkan oleh undang-undang atau sebaliknya, termasuk, namun tidak terbatas pada, jaminan yang tersirat mengenai jual beli, kesesuaian untuk tujuan tertentu, atau tidak adanya pelanggaran hak pihak ketiga, dengan ini dikecualikan dan dikesampingkan dengan batas tertinggi dan maksimum. Anda mengakui dan menyetujui bahwa seluruh risiko yang timbul dari penggunaan Layanan oleh Anda tetap semata-mata dan sepenuhnya ada pada Anda dan Anda tidak akan memiliki hak untuk meminta ganti rugi apapun dari Halo Jasa dan/atau PT.Halo Komunikasi Sejahtera.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Ganti rugi',
            subdata: [
              {
                title: 'Ganti rugi',
                content: [
                  {
                    text: `
                                        Dengan menggunakan Aplikasi ini, Anda setuju bahwa Anda akan membela, memberikan ganti rugi dan membebaskan kami, pemberi lisensi, afiliasi, dan masing-masing dari petugas, direktur, komisaris, karyawan, pengacara dan agen kami dari dan terhadap setiap dan semua klaim, biaya, kerusakan, kerugian, kewajiban dan biaya (termasuk biaya dan ongkos pengacara) yang timbul dari atau sehubungan dengan penggunaan Layanan dan/atau Aplikasi dan Situs Website oleh Anda, hubungan Anda dengan Penyedia Jasa, penyedia pihak ketiga pemasang iklan dan/atau sponsor, atau pelanggaran atas atau tidak dipatuhinya salah satu Ketentuan Penggunaan atau peraturan perundang-undangan yang berlaku, baik yang disebutkan di sini atau tidak atau pelanggaran Anda terhadap hak-hak pihak ketiga, termasuk Penyedia Jasa pihak ketiga yang diatur melalui Aplikasi, atau penggunaan atau penyalahgunaan Aplikasi. Kewajiban pembelaan dan pemberian ganti rugi ini akan tetap berlaku walaupun Ketentuan Penggunaan dan penggunaan Situs oleh Anda telah berakhir.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Perizinan',
            subdata: [
              {
                title: 'Perizinan',
                content: [
                  {
                    text: `
                                        Dengan tergantung pada kepatuhan Anda pada Ketentuan Penggunaan, kami memberikan Anda ijin yang terbatas, non-eksklusif, tidak dapat dipindahtangankan, tidak dapat dialihkan, tidak dapat disublisensikan, ijin yang dapat ditarik untuk mengunduh dan memasang salinan Aplikasi pada suatu perangkat bergerak tunggal yang Anda miliki atau kontrol dan menjalankan salinan Aplikasi semata-mata untuk kebutuhan pribadi, non-komersial Anda sendiri. <br /><br />
                                        Anda tidak diperkenankan (i) menyalin, memodifikasi, mengadaptasi, menerjemahkan, membuat karya turunan dari, mendistribusikan, memberikan lisensi, menjual, mengalihkan, menampilkan di muka umum, membuat ulang, mentransmisikan, memindahkan, menyiarkan, menguraikan, atau membongkar bagian manapun dari atau dengan cara lain yang mungkin mengeksploitasi Aplikasi dan Situs Website, kecuali sebagaimana diperbolehkan dalam Ketentuan Penggunaan ini, (ii) memberikan lisensi, mensublisensikan, menjual, menjual kembali, memindahkan, mengalihkan, mendistribusikan atau mengeksploitasi secara komersial atau membuat tersedia kepada pihak ketiga Aplikasi dan / atau perangkat lunak dengan cara; (iii) menciptakan "link" internet ke Aplikasi atau "frame" atau "mirror" setiap perangkat lunak pada server lain atau perangkat nirkabel atau yang berbasis internet; (iv) merekayasa ulang atau mengakses perangkat lunak kami untuk (a) membangun produk atau layanan tandingan, (b) membangun produk dengan menggunakan ide, fitur, fungsi atau grafis sejenis Aplikasi, atau (c) menyalin ide, fitur , fungsi atau grafis Aplikasi, (v) meluncurkan program otomatis atau script, termasuk, namun tidak terbatas pada, web spiders, web crawlers, web robots, web ants, web indexers, bots, virus atau worm, atau segala program apapun yang mungkin membuat beberapa permintaan server per detik, atau menciptakan beban berat atau menghambat operasi dan/atau kinerja Aplikasi, (vi) menggunakan robot, spider, pencarian situs/aplikasi pengambilan kembali, atau perangkat manual atau otomatis lainnya atau proses untuk mengambil, indeks, "tambang data" (data mine), atau dengan cara apapun memperbanyak atau menghindari struktur navigasi atau presentasi dari aplikasi atau isinya; (vii) menerbitkan, mendistribusikan atau memperbanyak dengan cara apapun materi yang dilindungi hak cipta, merek dagang, atau informasi yang dimiliki lainnya tanpa memperoleh persetujuan terlebih dahulu dari pemilik hak milik, (viii) menghapus setiap hak cipta, merek dagang atau pemberitahuan hak milik lainnya yang terkandung dalam aplikasi. Tidak ada lisensi atau hak yang diberikan kepada Anda dengan implikasi berdasarkan hak kekayaan intelektual dimiliki atau dikendalikan oleh kami atau pemberi lisensi kami, kecuali untuk lisensi dan hak tersebut secara tegas diberikan dalam Ketentuan Penggunaan ini. <br /><br />
                                        Anda tidak akan mengirim spam atau pesan yang bersifat duplikasi atau tidak diminta yang melanggar hukum berlaku; tidak akan mengirim atau menyimpan materi yang melanggar, cabul, mengancam, memfitnah, atau melanggar hukum atau bersifat sadis, termasuk namun tidak terbatas pada bahan berbahaya bagi anak-anak atau yang melanggar hak privasi pihak ketiga; tidak akan mengirim bahan yang mengandung virus piranti lunak, worm, trojan horses atau kode komputer berbahaya lainnya, dokumen/file, script, agen atau program; tidak mengganggu atau mengacaukan integritas atau kinerja Aplikasi atau data di dalamnya; tidak mencoba untuk mendapatkan akses yang tidak sah ke Aplikasi dan Situs Website dan/atau sistem atau jaringan terkait; tidak berkedok sebagai orang atau badan lain atau menggambarkan diri Anda sebagai afiliasi seseorang atau suatu badan; dan menahan diri untuk terlibat dalam tindakan yang mungkin bisa merusak reputasi kami atau dianggap dapat merusak reputasi kami. <br /><br />
                                        Kami akan memiliki hak untuk menyelidiki dan menuntut setiap pelanggaran di atas sepanjang yang dimungkinkan oleh hukum. Kami dapat melibatkan dan bekerja sama dengan pihak penegak hukum dalam menuntut pengguna yang melanggar Ketentuan Penggunaan ini. Anda mengakui bahwa kami tidak memiliki kewajiban untuk memonitor akses Anda ke atau penggunaan Situs web atau Aplikasi, tapi kami memiliki hak untuk melakukannya untuk tujuan pengoperasian Situs web dan Aplikasi, untuk memastikan kepatuhan dengan Ketentuan Penggunaan ini, atau untuk mematuhi peraturan yang berlaku atau perintah atau persyaratan dari pengadilan, lembaga administratif atau badan pemerintahan lainnya.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Hal-hal terkait kekayaan intelektual',
            subdata: [
              {
                title: 'Hal-hal terkait kekayaan intelektual',
                content: [
                  {
                    text: `
                                        PT. Halo Komunikasi Sejahtera atau dengan produknya Halo Jasa termasuk nama dan logo, Aplikasi dan Layanan, dilindungi oleh hak cipta, merek dagang dan hak-hak lain yang disediakan berdasarkan hukum Negara Republik Indonesia. Kami (dan pemberi lisensi kami, sebagaimana berlaku) secara eksklusif memiliki semua hak, kepemilikan dan kepentingan dalam dan terhadap Aplikasi dan Situs Website, termasuk semua hak kekayaan intelektual terkait. <br /><br />
                                        Tanpa menyimpang dari hak kami berdasarkan hukum yang berlaku atau Ketentuan Penggunaan, Anda diberitahukan bahwa setiap berusaha atau pelanggaran nyata atas ketentuan ini akan mengakibatkan penghentian semua hak Anda di bawah Ketentuan Penggunaan. Jika Anda menghindari salah satu cara yang kami ambil untuk melindungi layanan dari penggunaan secara tidak sah, Anda harus segera menghentikan setiap dan semua penggunaan Layanan, dan Anda setuju untuk melakukannya.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Syarat dan ketentuan',
            subdata: [
              {
                title: 'Syarat dan ketentuan',
                content: [
                  {
                    text: `
                                        Vendor Penyedia Jasa dan Pencari Jasa wajib memberikan informasi data diri selengkapnya dan sebenar-benarnya sesuai dengan kebutuhan masing-masing kategori jasa. <br /><br />
                                        Vendor Penyedia Jasa berkewajiban menjaga etika dan martabat Aplikasi dan Situs Website, Profesi, dan persatuan atau perkumpulan kategori jasa yang didaftarkan. <br /><br />
                                        Segala transaksi dilakukan melalui fasilitas E wallet dan yang disediakan oleh Halo Jasa. Jika Vendor Penyedia Jasa dan Pencari Jasa melakukan transaksi diluar fasilitas E-Wallet, maka pemberian rating dan komentar dari pencari jasa tidak dapat dilakukan. <br /><br />
                                        Vendor Penyedia Jasa Halo Jasa adalah Vendor penyedia jasa yang sudah mendapatkan arahan mengenai etika pemberian tenaga jasa dan konsultasi dan menyerahkan data berupa KTP, SKCK, dan sertifikasi khusus lainya sesuai bidang kategori jasa mereka.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Pembekuan akun Sementara dan Permanen',
            subdata: [
              {
                title: 'Pembekuan akun Sementara dan Permanen',
                content: [
                  {
                    text: `
                                        Anda tidak berkewajiban untuk menggunakan Aplikasi dan dapat memilih untuk berhenti menggunakannya setiap saat dengan membatalkan akun Anda dan secara permanen menghapus aplikasi dari perangkat Anda, sehingga menonaktifkan penggunaan Aplikasi tersebut. Ketentuan Penggunaan secara otomatis berakhir ketika Anda secara permanen menghapus aplikasi dari perangkat. <br /><br />
                                        Kami berhak untuk segera menangguhkan, membatasi atau menghentikan Ketentuan Penggunaan dan penggunaan Aplikasi jika kami memiliki alasan untuk mencurigai bahwa Anda telah melanggar ketentuan dari Ketentuan Penggunaan ini atau peraturan perundang-undangan yang berlakus seperti :
                                        <li>Bahwa dilaporan akun anda digunakan atau diduga digunakan atau disalahgunakan oleh orang lain atau di laporan kan bahwa perangkat telepon genggam anda atau tablet pribadi anda hilang, dicuri atau diretas.</li>
                                        <li>Bahwa kami mengetahui atau mempunyai alasan yang cukup untuk menduga bahwa akun Anda telah dialihkan atau digunakan oleh orang lain</li>
                                        <li>Bahwa kami mengetahui atau dengan alasan yang cukup menduga bahwa telah terjadi  permasalahan yang menurut pandangan Kami dapat dikatagorie kan kecurangan dan merugikan Kami, Anda, Vendor Penyedia Layanan atau pihak lainnya</li>
                                        <li>Bahwa sistem Kami mendeteksi adanya tindakan tidak wajar dari penggunaan akun Anda atau adanya kewajiban berdasarkan Ketentuan Penggunaan dan Kebijakan Privasi yang tidak dipenuhi oleh Anda<li>
                                        <li>Penggunaan Aplikasi Halo Jasa atau Layanan oleh Anda atau pihak lain (yang menggunakan Akun Anda) dengan cara yang bertentangan dengan Ketentuan Penggunaan ini, Kebijakan Privasi atau peraturan perundang-undangan yang berlaku</li>
                                        <li>Bahwa Kami mendapatkan perintah untuk pembekuan Akun, baik sementara atau permanen, yang diterbitkan oleh institusi pemerintah atau moneter terkait atau berdasarkan perintah pengadilan yang diterbitkan sesuai dengan peraturan perundang-undangan yang berlaku. </li>
                                        <br /><br />
                                        Jika terjadi permasalahan dalam pembekuan akun anda yang dirasa tidak seharusnya terjadi, Anda dapat membuat Laporan kepada Kami untuk menyampaikan bukti-bukti tersebut. <br /><br />
                                        Setelah kami melakukan pemeriksaan lebih lanjut terhadap Laporan Anda, kami akan menindaklanjuti untuk menentukan dan mengakhiri atau melanjutkan pembekuan terhadap akun Anda. <br /><br />
                                        Pengesampingan atau toleransi atau kegagalan kami untuk mengklaim suatu pelanggaran ketentuan dari Ketentuan Penggunaan ini atau untuk melaksanakan hak yang dinyatakan oleh Ketentuan Penggunaan ini atau hukum yang berlaku, tidak akan dianggap sebagai pengesampingan sehubungan dengan pelanggaran berikutnya dari setiap ketentuan dari Ketentuan Penggunaan ini.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Lain-lain',
            subdata: [
              {
                title: 'Lain-lain',
                content: [
                  {
                    text: `
                                        Ketentuan Penggunaan ini disusun dalam bahasa Inggris dan bahasa Indonesia, kedua versi akan mengikat Anda dan kami. Dalam hal terdapat ketidaksesuaian antara versi bahasa Indonesia dan versi bahasa Inggris, versi bahasa Indonesia yang akan berlaku. <br /><br />
                                        Anda tidak dapat memindahkan atau mengalihkan hak Anda berdasarkan Ketentuan Penggunaan, tanpa persetujuan tertulis sebelumnya dari kami. Kami dapat mengalihkan hak kami berdasarkan Ketentuan Penggunaan kepada pihak semata-mata dan mutlak menurut kebijakan kami. <br /><br />
                                        Vendor Penyedia Jasa dapat mengakhiri akun Anda dengan memberitahu kami maksud Anda untuk membatalkan akun Anda. Segala penghentian, termasuk mengembalikan Saldo Anda (tidak termasuk jumlah potongan yang diperoleh dari segala transaksi yang telah terjadi dan disetujui sebelumnya) dalam waktu 30 (tiga puluh) hari kerja. <br /><br />
                                        Dalam hal kematian, ahli waris Anda yang sah dengan pemberitahuan kepada kami dalam 30 (tiga puluh) hari kerja setelah kematian, dengan pernyataan yang sah yang dibuat sesuai dengan peraturan perundang-undangan yang berlaku atau keputusan pengadilan yang final dan mengikat, Vendor Penyedia Jasa dapat mengklaim saldo pada Dompet Tunai, namun terbatas pada nilai uang elektronik Anda. <br /><br />
                                        Pencari Jasa dan Vendor Penyedia Jasa dengan ini menyetujui bahwa Saldo yang telah dibayar melalui payement gateaway kami atau pilihan transaksi uang lainya tidak dapat ditarik kembali. <br /><br />
                                        Penyedia Jasa dapat mengambil atau mengklaim Saldo yang terdapat dalam wujud Dompet Tunai sebagai jumlah hasil kerja atau transaksi dengan jumlah potongan yang telah ditentukan dan disetujui sebelumnya oleh Halo Jasa. <br /><br />
                                        Jika ada istilah berdasarkan Ketentuan Penggunaan yang dianggap tidak sah, tidak berlaku atau tidak dapat dilaksanakan, baik secara keseluruhan atau sebagian, berdasarkan pengundangan atau ketentuan perundang-undangan, istilah atau bagian dari istilah tersebut akan, sepanjang, dianggap bukan bagian dari Ketentuan Penggunaan ini, namun legalitas, keabsahan atau keberlakuan dari Ketentuan Penggunaan selebihnya tidak akan terpengaruhi. <br /><br />
                                        Ketentuan Penggunaan ini diatur oleh dan ditafsirkan berdasarkan hukum Negara Republik Indonesia. Setiap dan semua sengketa yang timbul dari penggunaan layanan kami akan diatur oleh yurisdiksi eksklusif dari Pengadilan Negeri Jakarta Pusat. <br /><br />
                                        Ketentuan Penggunaan ini dapat dimodifikasi dan diubah dari waktu ke waktu. Kami akan memberitahu Anda melalui Aplikasi dan/atau email atas modifikasi, dan/atau perubahan atas Ketentuan Penggunaan. Penggunaan Aplikasi secara terus menerus setelah diterimanya pemberitahuan ini merupakan persetujuan dan penerimaan Anda atas modifikasi, dan/atau perubahan. <br /><br />
                                        HaloJasa <br /><br />
                                        Jl. KH. Wahid Hasyim No.162, RT.1/RW.9, Kecamatan Tanah Abang, Kelurahan Kp. Bali, Jakarta Pusat 10250
                                        `
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 6,
        title: 'Pembayaran',
        child: [
          {
            title: 'Cara pembayaran dengan Halo Point',
            subdata: [
              {
                title: 'Halo Point',
                content: [
                  {
                    text: `
                                        <p>Halo Point adalah reward yang anda dapatkan dan dapat digunakan sebagai sistem atau metode 
                                        pembayaran pada order atau pemesanan anda selanjutnya.</p>
                                        <p>Mulai sekarang, Halo Point yang sudah anda kumpulkan dari berbagai macam cashback bisa anda gunakan untuk 
                                        penggunaan berbagai macam layanan yang tersedia di layanan Halo Jasa.</p>
                                        `
                  }
                ]
              },
              {
                title: 'Cara Pembayaran Menggunakan Halo Point',
                content: [
                  {
                    text: `
                                        <p>Sebelum anda memesan layanan, periksa terlebih dahulu jumlah Halo Point anda di halaman utama / 
                                        Beranda pada aplikasi Halo Jasa anda. Pilih layanan pada menu kategori layanan yang ingin anda order / pesan. Kemudian..</p>
                                        <ol>
                                        <li>Masukkan informasi lengkap seperti alamat, dan waktu pengerjaan.</li>
                                        <li>Lalu pilih Halo Point sebagai metode pembayaran.</li>
                                        <li>Setelah memilih metode pembayaran, lanjutkan proses pemesanan dengan tap tombol Proses Pesanan</li>
                                        </ol>
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Cara pembayaran dengan Dana',
            subdata: [
              {
                title: 'Tentang Pembayaran Dana',
                content: [
                  {
                    text: `
                                        HALO JASA telah bekerja sama dengan DANA Indonesia dalam mengembangkan fitur pembayaran DANA di . DANA  merupakan fitur layanan uang elektronik (e-money) yang dapat digunakan sebagai alternatif pilihan metode pembayaran transaksi pada HALO JASA dan menampung dana sementara untuk transaksi yang dibatalkan (refund). Pengguna HALOJASA dapat menikmati fitur DANA mulai tanggal 08 Maret 2019. Berikut ini adalah beberapa keuntungan menggunakan fitur DANA, antara lain:
                                        <br /><br />
                                        <ul>
                                        <li>Proses pembayaran lebih cepat dan langsung di Halojasa.</li><br />
                                        <li>Order layanan Jasa lebih aman dengan menghubungkan akun DANA di HALOJASA.</li><br />
                                        <li>Kamu dengan mudah dapat melakukan top up saldo ke DANA.</li><br />
                                        <li>Keamanan transaksi terjamin karena dibangun dengan teknologi keamanan kelas dunia.</li><br />
                                        <li>Dapat membayar transaksi dengan metode mix payment antara Halo Point dan saldo DANA dengan mudah.</li><br />
                                        </ul>
                                        <br />
                                        HALO JASA telah bekerja sama dengan DANA Indonesia dalam mengembangkan fitur pembayaran DANA di . DANA  merupakan fitur layanan uang elektronik (e-money) yang dapat digunakan sebagai alternatif pilihan metode pembayaran transaksi pada HALO JASA dan menampung dana sementara untuk transaksi yang dibatalkan (refund). Pengguna HALOJASA dapat menikmati fitur DANA mulai tanggal 08 Maret 2019. Berikut ini adalah beberapa keuntungan menggunakan fitur DANA, antara lain:
                                        <br /><br />
                                        <ul>
                                        <li>Proses pembayaran lebih cepat dan langsung di Halojasa.</li><br />
                                        <li>Order layanan Jasa lebih aman dengan menghubungkan akun DANA di HALOJASA.</li><br />
                                        <li>Kamu dengan mudah dapat melakukan top up saldo ke DANA.</li><br />
                                        <li>Keamanan transaksi terjamin karena dibangun dengan teknologi keamanan kelas dunia.</li><br />
                                        <li>Dapat membayar transaksi dengan metode mix payment antara Halo Point dan saldo DANA dengan mudah.</li><br />
                                        `
                  }
                ]
              },
              {
                title: 'Cara Bayar Dengan Akun Dana',
                content: [
                  {
                    text: `
                                <p><span style="font-weight: 400;">Sebelum memesan layanan, periksa jumlah saldo Dana Anda dengan menekan nominal saldo Dana di layar utama aplikasi halo jasa.</span></p>
                                <ul>
                                <li><span style="font-weight: 400;">Pilih layanan pada katagorie tersedia yang anda inginkan untuk diorder.</span></li>
                                <li><span style="font-weight: 400;">Masukkan informasi lengkap seperti alamat dan waktu pengerjaan.&nbsp;</span></li>
                                <li><span style="font-weight: 400;">Lalu klik metode pembayaran dengan Dana.</span></li>
                                <li>Setelah memilih Dana, Anda sudah melakukan pemesanan.</li>
                                </ul>
                                        `
                  }
                ]
              },
              {
                title: 'Tentang Aktivasi Akun DANA',
                content: [
                  {
                    text: `
                                    <p><span style="font-weight: 400;">Untuk penguna HALO JASA yang ingin menggunakan metode pembayaran e-money khusunya DANA akan terlebih dahulu harus mengaktivasi akun DANA. Proses aktivasi akun DANA&nbsp; akan membutuhkan nomor handphone yang sedang aktif digunakan oleh anda. Terdapat 2 kondisi ketika akan mengaktivasi akun Dana, yaitu:</span></p>
                                    <ul>
                                    <li style="font-weight: 400;"><span style="font-weight: 400;">Penguna belum memiliki akun di Halo Jasa</span></li>
                                    </ul>
                                    <p><span style="font-weight: 400;">Pengguna dalam katagorie ini dapat melakukan pendaftaran akun pada HALO JASA dan aktivasi akun DANA dalam sekali proses. Dan proses aktivasi akun DANA memasukkan nomor handphone dan dilakukan di halaman Daftar Akun Halo Jasa.&nbsp;</span></p>
                                    <p><span style="font-weight: 400;">Langkah&nbsp; pembuatan akun Halo Jasa dan aktivasi akun DANA dapat dibaca di informasi selanjutnya.</span></p>
                                    <p>&nbsp;</p>
                                    <ul>
                                    <li style="font-weight: 400;"><span style="font-weight: 400;">Pengguna telah memiliki akun di Halo Jasa</span></li>
                                    </ul>
                                    <p><span style="font-weight: 400;">Sistem Halojasa akan mengarahkan Penguna yang belum memiliki akun Halojasa untuk melengkapi nomor handphone jika Penguna tersebut belum menyimpannya. Tombol aktivasi akun DANA di Halo jasa bisa ditemukan di halaman detail metode pembayaran ketika anda melakukan proces order dan teransaksi pada akun kami. Langkah-langkah aktivasi akun DANA bagi pengguna yang telah terdaftar dihalo jasa dapat dibaca di </span><span style="font-weight: 400;">informasi selanjutnya</span><span style="font-weight: 400;">.</span></p>
                                    `
                  }
                ]
              },
              {
                title: 'Cara Aktivasi Akun DANA',
                content: [
                  {
                    text: `
                                        Informasi ini merupakan langkah-langkah cara untuk melakukan aktivasi akun DANA di Halojasa:<br /><br />
                                        <ul>
                                        <li>
                                        Login ke akun Aplikasi Halo jasa.
                                        </li><br />
                                        <li>
                                        Masuk kehalaman Utama Aplikasi.
                                        </li><br />
                                        <li>
                                        Klik Logo bergambar dana dipojok kiri atas.
                                        </li><br />
                                        <li>
                                        Klik tombol Aktifkan.
                                        </li><br />
                                        <li>
                                        Masukan nomor handphone jika kamu belum melakukan registrasi sebelumnya
                                        </li><br />
                                        <li>
                                        Lanjutkan dengan melengkapi nomor handphone dan password login Halo Jasa.
                                        </li><br />
                                        <li>
                                        Sistem akan mengirim anda sms yang berisi kode OTP.
                                        </li><br />
                                        <li>
                                        Masukan kode OTP untuk mengkonfirmasi nomor handphone.
                                        </li><br />
                                        <li>
                                        Lanjutkan dengan set kode pin dalam angka dan maksimal memiliki 6 digit.
                                        </li><br />
                                        <li>
                                        Klik tombol Masuk untuk menyimpan.
                                        </li><br />
                                        </ul>
                                        `
                  }
                ]
              },
              {
                title: 'Cara Pemutusan Akun DANA',
                content: [
                  {
                    text: `
                                        Anda dapat memustukan akun Dana pada akun HaloJasa kapan pun, 
                                        fitur ini berfungsi untuk memutuskan hubungan antara akun DANA dengan akun Halojasa.<br /> <br /> 
                                        Fitur ini dibuat untuk membantu pengguna ketika nomor handphone yang digunakan di 
                                        akun DANA hilang atau tidak aktif, sehingga pengguna tidak bisa mendapatkan kode OTP 
                                        yang diperlukan untuk bertransaksi menggunakan metode pembayaran DANA.<br /> <br /> 
                                        Dengan adanya fitur ini, pengguna dapat melakukan aktivasi akun Halojasa dengan akun DANA yang baru. 
                                        `
                  }
                ]
              },
              {
                title: 'Syarat Pemutusan Akun Dana',
                content: [
                  {
                    text: `
                                        <ul>
                                        <li>
                                        Penguna layanan hanya bisa menghubungkan 1 akun dana ke 1 akun HALOJASA dengan nomor handphone yang sama.
                                        </li><br />
                                        <li>
                                        Untuk menghubungkan akun DANA baru, pastikan nomor handphone di HALOJASA sudah sama dengan nomor DANA yang akan diaktivasi.
                                        </li><br />
                                        <li>
                                        Saldo yang terdapat di akun DANA lama tidak akan berpindah ke akun DANA baru meskipun pengguna menghubungkannya ke akun DANA yang sama.
                                        </li><br />
                                        <li>
                                        Untuk pengguna yang ingin mencairkan saldo di akun DANA lama dengan menghubungi Customer Support DANA.
                                        </li><br />
                                        </ul>
                                        `
                  }
                ]
              },
              {
                title: 'Langkah Pemutusan Akun DANA',
                content: [
                  {
                    text: `
                                        <ul>
                                        <li>
                                        Login ke akun Aplikasi Halo jasa.
                                        </li><br />
                                        <li>
                                        Masuk kehalaman Utama Aplikasi.
                                        </li><br />
                                        <li>
                                        Klik Logo bergambar dana dipojok kiri atas.
                                        </li><br />
                                        <li>
                                        Klik tombol Putuskan Akun Dana.
                                        </li><br />
                                        </ul>
                                        <br />
                                        Pada layar akan muncul pop up yang akan mengarahkan pengguna untuk mengkonfirmasi pemutusan akun.
                                        `
                  }
                ]
              },
              {
                title: 'Pengembalian Saldo DANA dari transaksi yang dibatalkan',
                content: [
                  {
                    text: `
                                        Jika order layanan anda mengunakan metode pembayaran DANA, maka pembatalan layanan anda, saldo yang terpotong akan dikembalikan ke Saldo DANA.<br /><br />
                                        Pengembalian Dana<br /><br />
                                        Pengembalian dana dapat terjadi karena transaksi gagal atau dibatalkan oleh vendor kami. Anda tidak perlu khawatir karena proses pengembalian dana akan diproces secara langsung namun terkadang pengemablian dana oleh sistem membutuhkan waktu kurang dari 1x24 jam.
                                        <br /><br />
                                        Proses pengembalian uang akan diteruskan ke DANA apabila teransaksi anda mengunakan metode pembayaran dengan DANA.
                                        <br /><br />
                                        Anda dapat menunggu mutasi di Riwayat Transaksi dan kemudian dana akan dikembalikan ke Saldo DANA Anda.
                                        `
                  }
                ]
              }
            ]
          },
          {
            title: 'Mandiri bill payment',
            subdata: [
              {
                title: 'ATM Mandiri',
                content: [
                  {
                    text: 'Pada menu utama, pilih Bayar/Beli'
                  },
                  {
                    text: 'Pilih Lainnya'
                  },
                  {
                    text: 'Pilih Multi Payment'
                  },
                  {
                    text:
                      'Masukkan 70012 (kode perusahaan Midtrans) lalu tekan Benar'
                  },
                  {
                    text: 'Masukkan Kode Pembayaran Anda lalu tekan Benar'
                  },
                  {
                    text:
                      'Pada halaman konfirmasi akan muncul detail pembayaran Anda. Jika informasi telah sesuai tekan Ya'
                  }
                ]
              },
              {
                title: 'Internet Banking',
                content: [
                  {
                    text:
                      'Login ke Internet Banking Mandiri (https://ib.bankmandiri.co.id/)'
                  },
                  {
                    text: 'Pada menu utama, pilih Bayar, lalu pilih Multi Payment'
                  },
                  {
                    text:
                      'Pilih akun Anda di Dari Rekening, kemudian di Penyedia Jasa pilih Midtrans'
                  },
                  {
                    text: 'Masukkan Kode Pembayaran Anda dan klik Lanjutkan'
                  },
                  {
                    text: 'Konfirmasi pembayaran Anda menggunakan Mandiri Token'
                  }
                ]
              }
            ]
          },
          {
            title: 'Permata virtual account',
            subdata: [
              {
                title: 'Permata virtual account',
                content: [
                  {
                    text: 'Pada menu utama, pilih Transaksi Lainnya'
                  },
                  {
                    text: 'Pilih Pembayaran'
                  },
                  {
                    text: 'Pilih Pembayaran Lainnya'
                  },
                  {
                    text: 'Pilih Virtual Account'
                  },
                  {
                    text:
                      'Masukkan 16 digit No. Virtual Account yang dituju, lalu tekan Benar'
                  },
                  {
                    text:
                      'Pada halaman konfirmasi transfer akan muncul jumlah yang dibayarkan, nomor rekening, & nama Merchant. Jika informasi telah sesuai tekan Benar'
                  },
                  {
                    text: 'Pilih rekening pembayaran Anda dan tekan Benar'
                  }
                ]
              }
            ]
          },
          {
            title: 'Jaringan ATM bersama',
            subdata: [
              {
                title: 'Jaringan ATM bersama',
                content: [
                  {
                    text: 'Pada menu utama, pilih Transaksi Lainnya'
                  },
                  {
                    text: 'Pilih Transfer'
                  },
                  {
                    text: 'Pilih Antar Bank Online'
                  },
                  {
                    text:
                      'Masukkan 013 (kode Bank Permata) dan 16 digit No. Rekening'
                  },
                  {
                    text:
                      'Masukkan jumlah tagihan yang akan Anda bayar secara lengkap, Pembayaran dengan jumlah tidak sesuai akan otomatis ditolak'
                  },
                  {
                    text: 'Kosongkan No. Referensi, lalu tekan Benar'
                  },
                  {
                    text:
                      'Pada halaman konfirmasi transfer akan muncul jumlah yang dibayarkan, nomor rekening & nama Merchant. Jika informasi telah sesuai tekan Benar'
                  }
                ]
              }
            ]
          },
          {
            title: 'Jaringan ATM Prima',
            subdata: [
              {
                title: 'Jaringan ATM Prima',
                content: [
                  {
                    text: 'Pada menu utama, pilih Transaksi Lainnya'
                  },
                  {
                    text: 'Pilih Transfer'
                  },
                  {
                    text: 'Pilih Rek Bank Lain'
                  },
                  {
                    text: 'Masukkan nomor 013 (kode Bank Permata) lalu tekan Benar'
                  },
                  {
                    text:
                      'Masukkan jumlah tagihan yang akan Anda bayar secara lengkap, pembayaran dengan jumlah tidak sesuai akan otomatis ditolak'
                  },
                  {
                    text:
                      'Masukkan 16 digit No. Rekening pembayaran lalu tekan Benar'
                  },
                  {
                    text:
                      'Pada halaman konfirmasi transfer akan muncul jumlah yang dibayarkan, nomor rekening & nama Merchant. Jika informasi telah sesuai tekan Benar'
                  }
                ]
              }
            ]
          },
          {
            title: 'Jaringan ATM Alto',
            subdata: [
              {
                title: 'Jaringan ATM Alto',
                content: [
                  {
                    text: 'Pada menu utama, pilih Transaksi Lainnya'
                  },
                  {
                    text: 'Pilih Transfer'
                  },
                  {
                    text: 'Pilih Rek. Bank Lain'
                  },
                  {
                    text: 'Masukkan nomor 013 (kode Bank Permata) lalu tekan Benar'
                  },
                  {
                    text:
                      'Masukkan jumlah tagihan yang akan Anda bayar secara lengkap, pembayaran dengan jumlah tidak sesuai akan otomatis ditolak'
                  },
                  {
                    text:
                      'Masukkan 16 digit No. Rekening pembayaran lalu tekan Benar'
                  },
                  {
                    text:
                      'Pada halaman konfirmasi transfer akan muncul jumlah yang dibayarkan, nomor rekening & nama Merchant. Jika informasi telah sesuai tekan Benar'
                  }
                ]
              }
            ]
          },
          {
            title: 'Transaksi kartu kredit',
            subdata: [
              {
                title: 'Jaringan ATM ALTO',
                content: [
                  {
                    text: 'Pilih pembayaran melalui Kartu Kredit'
                  },
                  {
                    text:
                      'Masukkan 16 angka nomor kartu disertai dengan expiration date dan CVV'
                  },
                  {
                    text:
                      'Pastikan detail pembayaran Anda telah benar untuk melanjutkan ke step 3D Secure.'
                  },
                  {
                    text:
                      'One Time Password (OTP) akan dikirimkan ke nomor ponsel Anda yang terdaftar dengan kartu yang Anda gunakan.'
                  },
                  {
                    text: 'Masukkan OTP yang Anda dapat ke halaman 3D Secure.'
                  },
                  {
                    text: 'Pembayaran Anda dengan Kartu Kredit selesai.'
                  }
                ]
              }
            ]
          },
          {
            title: 'BCA Halo jasa',
            subdata: [
              {
                title: 'ATM BCA',
                content: [
                  {
                    text: 'Pilih ATM/Bank Transfer sebagai metode pembayaran.'
                  },
                  {
                    text: 'Pilih menu Transfer dan ke Rek BCA'
                  },
                  {
                    text:
                      'Masukkan Rekening Halo Jasa 0933-1688-99 an. Halo Komunikasi Sejahtera PT.'
                  },
                  {
                    text: 'Masukkan Nominal jumlah uang.'
                  },
                  {
                    text: 'Tekan OK.'
                  },
                  {
                    text: 'Ambil struk dan transaksi sudah selesai.'
                  },
                  {
                    text: 'Lakukan Konfirmasi Pembayaran di sistem halojasa.com.'
                  }
                ]
              },
              {
                title: 'm-BCA',
                content: [
                  {
                    text:
                      'Pastikan Rekening Halo Jasa 0933-1688-99 an. Halo Komunikasi Sejahtera PT sudah terdaftar di list daftar transfer anda.'
                  },
                  {
                    text: 'Pilih menu m-transfer dan tekan OK'
                  },
                  {
                    text: 'Pilih Antar Rek dan tekan OK/YES'
                  },
                  {
                    text:
                      'Masukkan Jumlah Uang yang akan ditransfer dan tekan OK/YES'
                  },
                  {
                    text:
                      'Pilih No. Rekening Tujuan yang akan ditransfer dan tekan OK/YES'
                  },
                  {
                    text:
                      'Masukkan keterangan berita yang dapat Anda isi/kosongkan. tekan OK/YES'
                  },
                  {
                    text: 'Masukkan PIN m-BCA Anda dan tekan OK/YES'
                  },
                  {
                    text: 'Transaksi Anda selesai.'
                  }
                ]
              }
            ]
          },
          {
            title: 'Transaksi virtual account BCA',
            subdata: [
              {
                title: 'Cara pembayaran via ATM BCA',
                content: [
                  {
                    text: 'Pada menu utama, pilih Transaksi Lainnya'
                  },
                  {
                    text: 'Pilih Transfer'
                  },
                  {
                    text: 'Pilih ke Rek BCA Virtual Account'
                  },
                  {
                    text: 'Masukkan nomor lalu tekan Benar'
                  },
                  {
                    text:
                      'Pada halaman konfirmasi transfer akan muncul detail pembayaran Anda. Jika informasi telah sesuai tekan Ya'
                  }
                ]
              },
              {
                title: 'Cara pembayaran via Klik BCA',
                content: [
                  {
                    text: 'Pilih menu Transfer Dana'
                  },
                  {
                    text: 'Pilih Transfer ke BCA Virtual Account'
                  },
                  {
                    text: 'Masukkan nomor BCA Virtual Account'
                  },
                  {
                    text:
                      'Jumlah yang akan ditransfer, nomor rekening dan nama merchant akan muncul di halaman konfirmasi pembayaran, jika informasi benar klik Lanjutkan'
                  },
                  {
                    text:
                      'Masukkan respon KEYBCA APPLI 1 yang muncul pada Token BCA Anda, lalu klik tombol Kirim'
                  },
                  {
                    text: 'Transaksi Anda selesai'
                  }
                ]
              },
              {
                title: 'Cara pembayaran via m-BCA',
                content: [
                  {
                    text: 'Pilih m-Transfer'
                  },
                  {
                    text: 'Pilih Transfer'
                  },
                  {
                    text: 'Pilih BCA Virtual Account'
                  },
                  {
                    text:
                      'Pilih nomor rekening yang akan digunakan untuk pembayaran'
                  },
                  {
                    text: 'Masukkan nomor BCA Virtual Account, lalu pilih OK'
                  },
                  {
                    text:
                      'Nomor BCA Virtual Account dan nomor Rekening Anda akan terlihat di halaman konfirmasi rekening, Pilih OK pada halaman konfirmasi pembayaran'
                  },
                  {
                    text: 'Masukkan PIN BCA untuk mengotorisasi pembayaran'
                  },
                  {
                    text: 'Transaksi Anda selesai'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 7,
        title: 'Frequently Asked Questions',
        child: [
          {
            title: 'Layanan Jasa',
            subdata: [
              {
                title: 'Bagaimana cara pelanggan memesan layanan di Halo Jasa?',
                content: [
                  {
                    text:
                      'Pelanggan dapat memesan melalui aplikasi Halo Jasa yang tersedia di platform Android dan iOS, unduh dan install aplikasi halo jasa dari Play Store (Android) / App Store (iOS)'
                  }
                ]
              },
              {
                title: 'Apakah pelangan dapat melakukan pembayaran ditempat?',
                content: [
                  {
                    text:
                      'Iya , kami memberikan kemudahan kepada setiap pelangan untuk semua kategori layanan Jasa, anda dapat melakukan pembayaran COD cash on delivery <a href="/bantuan/pusat-bantuan/">selengkapnya disini</a>'
                  }
                ]
              },
              {
                title: 'Apakah saya dapat melakukan order di website halojasa.com?',
                content: [
                  {
                    text:
                      'Saat ini pelangan hanya dapat melakukan order didalam aplikasi mobile.'
                  }
                ]
              },
              {
                title:
                  'Bagaimanakah pelanggan mengklaim garansi jika terjadi sesuatu setelah jasa selesai dilakukan?',
                content: [
                  {
                    text:
                      'Khusus untuk Halo Fix, terdapat waktu 7 hari untuk dapat klaim garansi jika hasil didapat kurang memuaskan melalui aplikasi'
                  }
                ]
              },
              {
                title:
                  'Apakah setelah pekerjaan selesai saya dapat memberikan rating dan tips?',
                content: [
                  {
                    text:
                      'Sebuah pengalaman dari hasil layanan yang terbaik merupakan tujuan kami kepada setiap pelangan ,dan kami berharap pelangan selalu memberikan penilaian kepada setiap hasil pekerjaan yang telah diselesaikan oleh vendor penyedia jasa kami apabila hasil pekerjaan vendor kami memuaskan untuk anda, dapat memberikan sebuah tips sebagai bentuk penghargaan melalui system yang telah kami sediakan <a href="/bantuan/pusat-bantuan/">pelajari selengkapnya disini</a>'
                  }
                ]
              },
              {
                title:
                  'Siapa sajakah brand ternama yang bekerja sama dengan Halo Jasa?',
                content: [
                  {
                    text:
                      'Katagori HALO MASSAGE dan HALO AUTO kami telah bekerja sama dengan Banyak perusahaan ternama dan telah bergabung dengan Halo Jasa memberikan layanan booking dan home service. Untuk lebih lengkap, pelanggan dapat memeriksa melalui layanan yang tersedia di aplikasi Halo Jasa.'
                  }
                ]
              }
            ]
          },
          {
            title: 'Programs & Promosi',
            subdata: [
              {
                title: 'Program cashback seperti apa yang ditawarkan Halo Jasa?',
                content: [
                  {
                    text:
                      'Saat ini program cashback hanya bisa diperoleh dengan transaksi melalui official merchant Halo Jasa.'
                  }
                ]
              },
              {
                title:
                  'Bagaimana perhitungan Halo Point yang diterima oleh pelanggan Halo Jasa?',
                content: [
                  {
                    text:
                      'Persentase Halo Point yang diterima pelanggan adalah 20% dari nilai transaksi pada satu order.'
                  }
                ]
              },
              {
                title: 'Bagaimana cara mendapatkan halopoint?',
                content: [
                  {
                    text:
                      'Anda bisa mendapatkan program cashback sebesar 5000 Halo point setiap bertransaksi dan menyelesaikan belanja anda pada aplikasi halo jasa, atau anda dapat berkesempatan mendapatkan 25000 Halo Point saat anda berhasil mengajak teman anda melakukan transaksi belanja.'
                  }
                ]
              },
              {
                title: 'Mengapa saya belum mendapatkan cashback?',
                content: [
                  {
                    text:
                      'Perhitungan cashback  anda akan masuk kehalo point ketika anda telah melakukan verifikasi email pada akun anda, cara aktifasi email <a href="/bantuan/pusat-bantuan/">informasi selengkapnya disini</a>'
                  }
                ]
              },
              {
                title:
                  'Selain cashback, rewards apa lagi yang diterima oleh pelanggan Halo Jasa?',
                content: [
                  {
                    text:
                      'Saat ini, Halo Jasa menawarkan promo cashback pada setiap order yang dilakukan melalui official merchant Halo Jasa.'
                  }
                ]
              },
              {
                title: 'Apakah kegunaan kode Voucher Diskon?',
                content: [
                  {
                    text:
                      'Kode voucher diskon dapat Anda gunakan untuk mendapatkan potongan harga layanan.'
                  }
                ]
              },
              {
                title: 'Bagaimana cara mendapatkan kode voucher diskon?',
                content: [
                  {
                    text:
                      'Kode voucher diskon promo akan di rilis pada momen tertentu sesuai ketentuan pada layanan kami. Promo kode voucher ini bisa Anda temukan juga pada akun sosial media Halo Jasa di Facebook, Instagram, Twitter, maupun melalui email promosi. Anda juga cek langsung pada laman aplikasi Halo Jasa Anda.'
                  }
                ]
              }
            ]
          },
          {
            title: 'Pembayaran',
            subdata: [
              {
                title:
                  'Metode pembayaran apa sajakah yang disediakan untuk bertrasaksi?',
                content: [
                  {
                    text:
                      'Pada apalikasi halo jasa anda akan mendapatkan beberapa kemudahan dalam bertrasaksi, anda dapat mengunakan pembayaran via transver bank , virtual account, e money favorite , kartu credit dan lain nya, <a href="/bantuan/pusat-bantuan/">informasi selengkapnya disini</a>'
                  }
                ]
              },
              {
                title:
                  'Apakah pelangan dapat bertransaksi dengan mengunakan e-money saldo Dana?',
                content: [
                  {
                    text:
                      'Anda dapat menggunakan metode pembayaran dengan beberapa chanel e money seperti DANA dan OVO untuk melakukan pembayaran dari setiap order pemesanan layanan jasa pada aplikasi kami.'
                  }
                ]
              },
              {
                title:
                  'Apakah pelanggan tetap dapat memesan layanan di Halo Jasa saat saldo DANA/OVO mereka habis atau kurang?',
                content: [
                  {
                    text:
                      'Pelanggan tidak bisa memesan menggunakan DANA atau OVO jika saldo yang dimiliki kurang. Alternatifnya tersedia opsi pembayaran lain tersedia seperti Cash On Delivery (Pembayaran di tempat) maupun menggunakan cashback Halo Point.'
                  }
                ]
              },
              {
                title:
                  'Apakah saya dapat mengunakan pembayaran via E-money DANA dan bisa mengabungkan metode pembayaran COD seperti E money + Tunai?',
                content: [
                  {
                    text:
                      'Tidak, anda tidak dapat mengabungkan metode pembayaran antara tunai dan e money, hanya memilih salah satu.'
                  }
                ]
              },
              {
                title:
                  'Apakah pembayaran melalui COD (Cash On Delivery) dapat menambah jumlah Halo Point saya?',
                content: [
                  {
                    text:
                      'Ya bisa, seluruh metode transaksi anda akan mendapatkan point.'
                  }
                ]
              },
              {
                title:
                  'Apakah pembayaran dengan mengunakan e money DANA dan OVO bisa digabung dengan kode promo halo jasa?',
                content: [
                  {
                    text:
                      'Ya, metode pembayaran Emoney kami dapat digabung dengan kode promo dan anda tetap mendapatkan promosi nya.'
                  }
                ]
              }
            ]
          },
          {
            title: 'Aplikasi & Teknis',
            subdata: [
              {
                title: 'Mengapa Apps selalu Log Out secara tiba-tiba?',
                content: [
                  {
                    text:
                      'Silahkan melakukan update pada versi aplikasi anda, lalu kembali untuk melakukan Login ulang , hal ini dikarenakan bisa terjadi dikarenakan versi aplikasi anda yang belum terupdate.'
                  }
                ]
              },
              {
                title:
                  'Apa yang harus dilakukan saat Apps Halo Jasa mendadak crash?',
                content: [
                  {
                    text:
                      'Silahkan pastikan koneksi internet masih terhubung. Jika telah terhubung namun terus berulang, silahkan kontak Costumer Support untuk bantuan lebih lanjut.'
                  }
                ]
              },
              {
                title: 'Apakah App Halo Jasa dapat dibagikan kepada orang lain?',
                content: [
                  {
                    text:
                      'Tidak. Jangan pernah membagikan password, nomor telepon, dan OTP (One Time Password) kepada siapapun.'
                  }
                ]
              },
              {
                title: 'Bagaimana jika lupa password dan nomor telp?',
                content: [
                  {
                    text:
                      'Silahkan menghubungi Customer Support Halo Jasa untuk bantuan lebih lanjut.'
                  }
                ]
              },
              {
                title:
                  'Saldo DANA tidak muncul maupun tidak sesuai jumlahnya di dalam aplikasi, apa yang harus dilakukan?',
                content: [
                  {
                    text:
                      'Cek akun anda pada aplikasi DANA, apabila terjadi perbedaan nilai saldo , Silahkan menghubungi DANA untuk meminta bantuan lebih lanjut.'
                  }
                ]
              },
              {
                title: 'Mengapa akun saya di blokir?',
                content: [
                  {
                    text:
                      'Akun anda diblokir bisa dipengaruhi oleh beberapa faktor, pertama anda melakukan permintaan authentifikasi sms verifikasi code terlalu banyak, dan yang kedua anda terlalu sering melakukan cancel order, <a href="/bantuan/pusat-bantuan/">informasi selengkapnya disini</a>'
                  }
                ]
              },
              {
                title:
                  'Bagaimana cara mengembalikan akun pelanggan jika terindikasi terkena Peretasan?',
                content: [
                  {
                    text:
                      'Jika terindikasi terkena peretasan, ataupun perangkat handphone anda hilang, pelanggan dapat menghubungi Customer Support untuk mendapatkan bantuan memblokir akun anda, dan diperlukan verifikasi serta bukti data data kepemilikan akun agar dapat melakukan aktifasi kembali.'
                  }
                ]
              },
              {
                title:
                  'Bagaimana cara mengganti akun pelanggan jika berpindah handphone?',
                content: [
                  {
                    text:
                      'Akun anda tidak bisa dibuka jika lebih dari dua handphone. Jika satu handphone baru membuka akun yang sama, anda dapat melakukan authentifikasi ulang ke email anda dan otomatis akun Halo Jasa di handphone lama akan log off dengan sendirinya, <a href="/bantuan/pusat-bantuan/">selengkapnya disini</a>'
                  }
                ]
              }
            ]
          },
          {
            title: 'Vendor',
            subdata: [
              {
                title:
                  'Apakah wajib memberikan tip kepada penyedia jasa usai layanan selesai dilakukan?',
                content: [
                  {
                    text:
                      'Tidak. Namun pelanggan dapat memberikan tips kepada vendor kami melalui system yang telah di buat didalam aplikasi ketika usai layanan selesai dilakukan, dan ini bukan kewajiban yang anda harus lakukan.'
                  }
                ]
              },
              {
                title: 'Bagaimana cara memberikan rating kepada penyedia jasa?',
                content: [
                  {
                    text:
                      'Rating kepada penyedia jasa akan tersedia usai penyedia jasa selesai melaksanakan pesanannya, anda dapat memberikan rating berdasarkan bintang 1- 5 berdasarkan kepuasan akan pelayanan yang vendor lakukan , anda dapat memberikan saran untuk meningkatkan layanan vendor baik, dari segi durasi pelaksanaan kerja , kualitas pekerjaan, profesionalisme , ketepatan waktu , keramahan, dan yang terakhir anda juga dapat memberikan komentar tambahan yang telah kami sediakan'
                  }
                ]
              },
              {
                title:
                  'Apakah bisa memesankan penyedia jasa kepada orang lain melalui aplikasi?',
                content: [
                  {
                    text: 'Tentu anda dapat melakukan pemesanan untuk orang lain.'
                  }
                ]
              },
              {
                title:
                  'Apakah pelanggan dapat mengganti penyedia jasa saat dia telah sampai di lokasi pekerjaan?',
                content: [
                  {
                    text:
                      'Tidak bisa dikarenakan permintaan order yang telah anda pesan pemilihan nya akan dibroadcast oleh system dengan ketersedian vendor dan juga lokasi terdekat, dan ketika penyedia jasa melakukan konfirmasi pemesanan anda , maka order tidak dapat dibatalkan.'
                  }
                ]
              },
              {
                title:
                  'Saldo DANA tidak muncul maupun tidak sesuai jumlahnya di dalam aplikasi, apa yang harus dilakukan?',
                content: [
                  {
                    text:
                      'Pada katagorie tertentu fitur kami dapat penyimpan vendor favorite setelah anda melakukan order pertama dan akan tersimpan pada halaman vendor favorite dan anda dapat memilih vendor tersebut ketika anda melakukan order kembali di order berikutnya.'
                  }
                ]
              },
              {
                title:
                  'Apa yang bisa dilakukan saat vendor kami saat mendapatkan perintah kerja yang tidak sesuai dengan layanan yang dipesan oleh pelangan?',
                content: [
                  {
                    text:
                      'Vendor dapat menolak dan melanjutkan standart kerja yang disesuaikan dengan pemesanan pelangan.'
                  }
                ]
              },
              {
                title:
                  'Apa yang bisa dilakukan saat vendor ketika terjadi pelanggaran asusila?',
                content: [
                  {
                    text:
                      'Vendor dapat menekan tombol Panic Button yang terdapat di aplikasi Halo Jasa untuk meminta pertolongan jika hal-hal tidak diinginkan terjadi.'
                  }
                ]
              },
              {
                title:
                  'Apakah dapat memilih preferensi penyedia jasa berdasarkan kategori tertentu?',
                content: [
                  {
                    text:
                      'Anda dapat memilih preferensi berdasarkan jenis kelamin dan usia untuk kategori Halo Massage. Layanan lain dapat dipilih oleh pelanggan baik secara perusahaan maupun perseorangan.'
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]

export const DataPay = [
  {
    id: 1,
    title: 'Halo Point',
    child: [
      {
        title: 'Cara pembayaran dengan Halo Point',
        subdata: [
          {
            title: 'Halo Point',
            content: [
              {
                text: `
                                        <p>Halo Point adalah reward yang anda dapatkan dan dapat digunakan sebagai sistem atau metode 
                                        pembayaran pada order atau pemesanan anda selanjutnya.</p>
                                        <p>Mulai sekarang, Halo Point yang sudah anda kumpulkan dari berbagai macam cashback bisa anda gunakan untuk 
                                        penggunaan berbagai macam layanan yang tersedia di layanan Halo Jasa.</p>
                                        `
              }
            ]
          },
          {
            title: 'Cara Pembayaran Menggunakan Halo Point',
            content: [
              {
                text: `
                                        <p>Sebelum anda memesan layanan, periksa terlebih dahulu jumlah Halo Point anda di halaman utama / 
                                        Beranda pada aplikasi Halo Jasa anda. Pilih layanan pada menu kategori layanan yang ingin anda order / pesan. Kemudian..</p>
                                        <ol>
                                        <li>Masukkan informasi lengkap seperti alamat, dan waktu pengerjaan.</li>
                                        <li>Lalu pilih Halo Point sebagai metode pembayaran.</li>
                                        <li>Setelah memilih metode pembayaran, lanjutkan proses pemesanan dengan tap tombol Proses Pesanan</li>
                                        </ol>
                                        `
              }
            ]
          }
        ]
      }
    ]
  }
]
